import React from 'react';
import logo from '../ginkgo.png';
import { withRouter } from "react-router-dom";
import { 
  DollarCircleOutlined, 
  TeamOutlined, 
  BankOutlined, 
  TrophyOutlined,
  BuildOutlined,
  FileTextOutlined,
  CalculatorOutlined,
  DownloadOutlined,
  UserOutlined
} from '@ant-design/icons';

import '../App.css';
import axios from 'axios';
import { baseURL } from '../API/url';
import { sessionManager, setupAxiosInterceptors } from '../utils/sessionManager';
import moment from 'moment';
import dayjs from 'dayjs';
import RedemptionPoolChart, {
  getActiveRedemptionTotal,
  isRedemptionPeriodLocked,
} from './RedemptionPoolChart';
import RedemptionRequestTable from './RedemptionRequestTable';
import RedemptionBookingTable from './RedemptionBookingTable';
import UserManagementModal from './UserManagementModal';
import AdvisorManagementModal from './AdvisorManagementModal';
import EMDManagementModal from './EMDManagementModal';
import { buildListHeader } from '../utils/listSummary';
import { 
  Form, 
  DatePicker, 
  Button, 
  Typography, 
  Card, 
  Row, 
  Col, 
  Table, 
  Statistic, 
  Tabs, 
  Select,
  Space,
  Descriptions,
  Divider,
  Modal,
  Input,
  Collapse,
  Radio,
  Popconfirm,
  Tooltip,
  message
} from 'antd';

import { PDFDocument } from 'pdf-lib';
import download from 'downloadjs';

const { RangePicker } = DatePicker;
const { Title } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;
const { Panel } = Collapse;
const dateFormat = 'MM-DD-YYYY';
const DB_dateFormat = 'YYYY-MM-DD';

const getDefaultRedemptionPeriod = () => {
  const target = moment();
  return {
    month: target.month(),
    year: target.year(),
  };
};

interface AdminState {
  isAuthenticated: boolean;
  userEmail: string | null;
  loading: boolean;
  emdFirms: any[];
  selectedEMDId: string | null;
  selectedEMD: any | null;
  adminSummary: {
    totalEMDFirms: number;
    totalAdvisors: number;
    totalClients: number;
    totalAssets: string;
    emdSummary: any[];
  };
  activeTab: string;
  // Modal states
  isEMDListModalOpen: boolean;
  emdSearchText: string;
  // Admin info
  adminInfo: any | null;
  
  // EMD Dashboard data (when an EMD is selected)
  advisors: any[];
  selectedAdvisorId: string | null;
  selectedAdvisor: any | null;
  advisorClients: any[];
  advisorAssets: any[];
  emdSummary: {
    totalAdvisors: number;
    totalClients: number;
    totalAssets: string;
    advisorSummary: any[];
  };
  // Modal states for EMD dashboard
  isAdvisorListModalOpen: boolean;
  advisorSearchText: string;
  // EMD info
  emdInfo: any | null;
  // Transaction and certificate data
  transactionData: any[];
  certData: any[];
  commData: any[];
  redeemData: any[];
  certDataAdvisor: any[];
  commDataAdvisor: any[];
  transactionStartDate: string;
  transactionEndDate: string;
  certStartDate: string;
  certEndDate: string;
  partnersData: any[];
  currentAccountRecId: string;
  totalAccountValue: any[];
  totalAccountsValue: number;
  totalAccountTrailerFees: number;
  totalAccountsTrailerFees: number;
  certTrailerFees: any[];
  displayAccountNum: string;
  displayAdvisorType: string;
  transactionProductId: string;
  certificateProductId: string;
  certificateProductName: string;
  partner: any;
  certSub_total: number;
  selectedYear: string;
  subTotalFeesOnYears: Array<{year: number; total: number}>;
  selectedYearCommTotal: number[];
  currentMonthFeesTotal: string;
  currentYear: number;
  currentMonth: number;
  isModalOpen: boolean;
  clientListLoading: boolean;
  selectedPartnerSin: string;
  clientListData: any[];
  clientList: any[];
  // All Client List (every advisor's clients, searched server-side)
  isAllClientListModalOpen: boolean;
  allClientList: any[];
  allClientTotal: number;
  allClientPage: number;
  allClientPageSize: number;
  allClientListLoading: boolean;
  allClientSearchText: string;
  allClientSortField: string | null;
  allClientSortOrder: 'ascend' | 'descend' | null;
  selectedAllClient: any | null;
  isUserManagementOpen: boolean;
  isAdvisorMgmtOpen: boolean;
  isEmdMgmtOpen: boolean;
  userId: string;
  advisorId: string;
  userType: string;
  totalClient: number;
  totalAsset: number;
  clientTotalValue: number;
  selectedCommMonth: number;
  selectedCommYear: string;
  searchText: string;
  // Redemption report modal states
  isRedemptionReportModalOpen: boolean;
  selectedReportMonth: string;
  // Commission report modal states
  isCommissionReportModalOpen: boolean;
  selectedCommissionMonth: string;
  // T5/NR4 report modal states
  isT5NR4ReportModalOpen: boolean;
  selectedT5NR4Year: string;
  selectedT5NR4Product: string;
  selectedT5NR4AccNum: string;
  // VIP List modal states
  isVIPListModalOpen: boolean;
  selectedVIPProvince: string;
  selectedVIPMinValue: string;
  mcpQueryFirstRecord: any | null;
  // Redemption request section (below the pool charts)
  redemptionMonth: number;
  redemptionYear: number;
  dripTotal: number;
  newPurchaseTotal: number;
  redemptionRecords: any[];
  redemptionLoading: boolean;
  bookingRecords: any[];
  bookingLoading: boolean;
  totalMatch: number;
  totalNonMatch: number;
  totalRetracted: number;
  matchedCount: number;
  matchPeriodAllocated: number;
  matching: boolean;
  completingMatches: boolean;
  statusEmailSent: boolean;
  statusEmailSentAt: string | null;
  sendingStatusEmail: boolean;
  partnerOptions: Array<{ recId: string; name: string }>;
  advisorOptions: Array<{ recId: string; name: string }>;
  emdOptions: Array<{ recId: string; name: string }>;
  // Catergories of a single partner (Client Portfolio row)
  isPartnerCatergoryModalOpen: boolean;
  partnerCatergoryRecId: string;
  partnerCatergoryAccount: string;
  partnerCatergoryList: Array<{ recId: string; description: string; selected: boolean }>;
  partnerCatergorySelectedKeys: string[];
  partnerCatergoryLoading: boolean;
  // Catergories management (whole catergory table)
  isCatergoryMgmtModalOpen: boolean;
  catergoryRows: Array<{ recId: string; description: string; isNew?: boolean; isEdited?: boolean }>;
  catergorySelectedKeys: string[];
  catergoryRemovedRecIds: string[];
  catergoryNewValue: string;
  catergoryEditingRecId: string | null;
  catergoryMgmtLoading: boolean;
}

// Static sample rows shown in the Redemption Requests table when the database
// has no records for the selected month/year (so the editable table + Edit
// buttons are always visible).
const STATIC_REDEMPTION_ROWS = [
  {
    recId: 'static-1',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Annisa Ng',
    account: 'ONTF180249',
    advisorName: 'IBP',
    emdFirm: 'IBP Capital Inc',
    amount: 140361.00,
    dateRequest: '2026-06-02',
    queueNumber: 1,
    status: 'Matched',
  },
  {
    recId: 'static-2',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Libo Wang',
    account: 'FOR00090',
    advisorName: 'Angel Lin',
    emdFirm: 'Enoch Wealth Inc',
    amount: 250000.00,
    dateRequest: '2026-06-05',
    queueNumber: 2,
    status: 'Matched',
  },
  {
    recId: 'static-3',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Yen Fang Huang',
    account: 'FOR00124',
    advisorName: 'Raymond Keung',
    emdFirm: 'Waverley',
    amount: 65502.00,
    dateRequest: '2026-06-06',
    queueNumber: 3,
    status: 'Matched',
  },
  {
    recId: 'static-4',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Qian Wang',
    account: 'BCTF340952',
    advisorName: 'Ralph He',
    emdFirm: 'Raisen Pacific Wealth',
    amount: 24693.72,
    dateRequest: '2026-06-07',
    queueNumber: 4,
    status: 'Matched',
  },
  {
    recId: 'static-5',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Yanzhen Jia/ Qifei Bo',
    account: 'ON00265',
    advisorName: 'Luyang Yan',
    emdFirm: 'Enoch Wealth Inc',
    amount: 50500.00,
    dateRequest: '2026-06-08',
    queueNumber: 5,
    status: 'Matched',
  },
  {
    recId: 'static-6',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Kindson International Inc.',
    account: 'OCORP00038',
    advisorName: 'IBP',
    emdFirm: 'IBP Capital Inc',
    amount: 100500.00,
    dateRequest: '2026-06-09',
    queueNumber: 6,
    status: 'Matched',
  },
  {
    recId: 'static-7',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Alex Yuen',
    account: 'ONRF255546',
    advisorName: 'IBP',
    emdFirm: 'IBP Capital Inc',
    amount: 15000.00,
    dateRequest: '2026-06-09',
    queueNumber: 7,
    status: 'Matched',
  },
  {
    recId: 'static-8',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Ping Fu MPC',
    account: 'OCORP00006',
    advisorName: 'IBP',
    emdFirm: 'IBP Capital Inc',
    amount: 1000000.00,
    dateRequest: '2026-06-09',
    queueNumber: 8,
    status: 'Matched',
  },
  {
    recId: 'static-9',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Lian Rong Liu',
    account: 'FOR00097',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 200000.00,
    dateRequest: '2026-06-11',
    queueNumber: 9,
    status: 'Pending',
  },
  {
    recId: 'static-10',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Edward Kirkland Feng Xiao',
    account: 'BC00149',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 10000.00,
    dateRequest: '2026-06-11',
    queueNumber: 10,
    status: 'Pending',
  },
  {
    recId: 'static-11',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Dennis Tsz Wing Kong',
    account: 'BC00213',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 19605.61,
    dateRequest: '2026-06-11',
    queueNumber: 11,
    status: 'Pending',
  },
  {
    recId: 'static-12',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Dennis Tsz Wing Kong',
    account: 'BCTF133760',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 32894.88,
    dateRequest: '2026-06-14',
    queueNumber: 12,
    status: 'Pending',
  },
  {
    recId: 'static-13',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Tina Tsiao Nien Tso',
    account: 'BC00239',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 3697.77,
    dateRequest: '2026-06-15',
    queueNumber: 13,
    status: 'Pending',
  },
  {
    recId: 'static-14',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Tuen Yee Phyllis Chan',
    account: 'BCRF253493',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 7415.32,
    dateRequest: '2026-06-15',
    queueNumber: 14,
    status: 'Pending',
  },
  {
    recId: 'static-15',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Chee Chung Cheung',
    account: 'BC00209',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 50000.00,
    dateRequest: '2026-06-15',
    queueNumber: 15,
    status: 'Pending',
  },
  {
    recId: 'static-16',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Dan Jin',
    account: 'BCRS142731',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 7000.00,
    dateRequest: '2026-06-16',
    queueNumber: 16,
    status: 'Pending',
  },
  {
    recId: 'static-17',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Dan Jin',
    account: 'BCTF142729',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 6700.00,
    dateRequest: '2026-06-16',
    queueNumber: 17,
    status: 'Pending',
  },
  {
    recId: 'static-18',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Cheng Hsu',
    account: 'BC00123',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 40000.00,
    dateRequest: '2026-06-18',
    queueNumber: 18,
    status: 'Pending',
  },
  {
    recId: 'static-19',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Lin Jiang',
    account: 'ONTF207291',
    advisorName: 'IBP',
    emdFirm: 'IBP Capital Inc',
    amount: 60000.00,
    dateRequest: '2026-06-19',
    queueNumber: 19,
    status: 'Pending',
  },
  {
    recId: 'static-20',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Jian Xiong Wang',
    account: 'BCRS143966',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 23168.32,
    dateRequest: '2026-06-21',
    queueNumber: 20,
    status: 'Pending',
  },
  {
    recId: 'static-21',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Janet Lui',
    account: 'BCTF208115',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 80000.00,
    dateRequest: '2026-06-21',
    queueNumber: 21,
    status: 'Pending',
  },
  {
    recId: 'static-22',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Samuel Wong',
    account: 'ONTF173133',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 7000.00,
    dateRequest: '2026-06-26',
    queueNumber: 22,
    status: 'Pending',
  }
];

class PortfolioAdmin extends React.Component<any, AdminState> {
  constructor(props: any) {
    super(props);
    const defaultRedemptionPeriod = getDefaultRedemptionPeriod();
    
    // Setup axios interceptors for session management
    setupAxiosInterceptors(axios);
    
    this.state = {
      isAuthenticated: props.isAuthenticated || false,
      userEmail: null,
      loading: true,
      emdFirms: [],
      selectedEMDId: null,
      selectedEMD: null,
      adminSummary: {
        totalEMDFirms: 0,
        totalAdvisors: 0,
        totalClients: 0,
        totalAssets: '$0.00',
        emdSummary: []
      },
      activeTab: 'admin-summary',
      // Modal states
      isEMDListModalOpen: false,
      emdSearchText: '',
      // Admin info
      adminInfo: null,
      
      // EMD Dashboard data (when an EMD is selected)
      advisors: [],
      selectedAdvisorId: null,
      selectedAdvisor: null,
      advisorClients: [],
      advisorAssets: [],
      emdSummary: {
        totalAdvisors: 0,
        totalClients: 0,
        totalAssets: '$0.00',
        advisorSummary: []
      },
      // Modal states for EMD dashboard
      isAdvisorListModalOpen: false,
      advisorSearchText: '',
      // EMD info
      emdInfo: null,
      transactionData: [],
      certData: [],
      commData: [],
      redeemData: [],
      certDataAdvisor: [],
      commDataAdvisor: [],
      transactionStartDate: moment().dayOfYear(1).format(dateFormat),
      transactionEndDate: moment().format(dateFormat),
      certStartDate: moment().dayOfYear(1).format(dateFormat),
      certEndDate: moment().format(dateFormat),
      partnersData: [],
      currentAccountRecId: '',
      totalAccountValue: [],
      totalAccountsValue: 0,
      totalAccountTrailerFees: 0,
      totalAccountsTrailerFees: 0,
      certTrailerFees: [],
      displayAccountNum: '',
      displayAdvisorType: '',
      transactionProductId: '',
      certificateProductId: '',
      certificateProductName: '',
      partner: {},
      certSub_total: 0,
      selectedYear: moment().dayOfYear(1).format(dateFormat),
      subTotalFeesOnYears: [
        {year: moment().subtract(9, "years").year(), total: 0}, 
        {year: moment().subtract(8, "years").year(), total: 0}, 
        {year: moment().subtract(7, "years").year(), total: 0}, 
        {year: moment().subtract(6, "years").year(), total: 0}, 
        {year: moment().subtract(5, "years").year(), total: 0}, 
        {year: moment().subtract(4, "years").year(), total: 0},
        {year: moment().subtract(3, "years").year(), total: 0}, 
        {year: moment().subtract(2, "years").year(), total: 0}, 
        {year: moment().subtract(1, "years").year(), total: 0}, 
        {year: moment().year(), total: 0}
      ],
      selectedYearCommTotal: [0,0,0,0,0],
      currentMonthFeesTotal: '',
      currentYear: moment().year(),
      currentMonth: moment().month(),
      isModalOpen: false,
      clientListLoading: false,
      selectedPartnerSin: '',
      clientListData: [],
      clientList: [],
      isAllClientListModalOpen: false,
      allClientList: [],
      allClientTotal: 0,
      allClientPage: 1,
      allClientPageSize: 10,
      allClientListLoading: false,
      allClientSearchText: '',
      allClientSortField: null,
      allClientSortOrder: null,
      selectedAllClient: null,
      isUserManagementOpen: false,
      isAdvisorMgmtOpen: false,
      isEmdMgmtOpen: false,
      userId: '',
      advisorId: '',
      userType: '',
      totalClient: 0,
      totalAsset: 0,
      clientTotalValue: 0,
      selectedCommMonth: moment().subtract(1, 'months').month(),
      selectedCommYear: moment().format('YYYY'),
      searchText: '',
      // Redemption report modal states
      isRedemptionReportModalOpen: false,
      selectedReportMonth: (() => {
        const currentDay = moment().date();
        if (currentDay >= 18) {
          return moment().subtract(1, 'months').format('YYYY-MM');
        } else {
          return moment().subtract(2, 'months').format('YYYY-MM');
        }
      })(),
      // Commission report modal states
      isCommissionReportModalOpen: false,
      selectedCommissionMonth: (() => {
        const currentDay = moment().date();
        if (currentDay >= 18) {
          return moment().add(1, 'months').format('YYYY-MM');
        } else {
          return moment().subtract(0, 'months').format('YYYY-MM');
        }
      })(),
      // T5/NR4 report modal states
      isT5NR4ReportModalOpen: false,
      selectedT5NR4Year: moment().subtract(1, 'year').format('YYYY'),
      selectedT5NR4Product: '',
      selectedT5NR4AccNum: '',
      // VIP List modal states
      isVIPListModalOpen: false,
      selectedVIPProvince: '',
      selectedVIPMinValue: '$5000',
      mcpQueryFirstRecord: null,
      // Redemption request section
      redemptionMonth: defaultRedemptionPeriod.month,
      redemptionYear: defaultRedemptionPeriod.year,
      dripTotal: 0,
      newPurchaseTotal: 0,
      redemptionRecords: [],
      redemptionLoading: false,
      bookingRecords: [],
      bookingLoading: false,
      totalMatch: 0,
      totalNonMatch: 0,
      totalRetracted: 0,
      matchedCount: 0,
      matchPeriodAllocated: 0,
      matching: false,
      completingMatches: false,
      statusEmailSent: false,
      statusEmailSentAt: null,
      sendingStatusEmail: false,
      partnerOptions: [],
      advisorOptions: [],
      emdOptions: [],
      isPartnerCatergoryModalOpen: false,
      partnerCatergoryRecId: '',
      partnerCatergoryAccount: '',
      partnerCatergoryList: [],
      partnerCatergorySelectedKeys: [],
      partnerCatergoryLoading: false,
      isCatergoryMgmtModalOpen: false,
      catergoryRows: [],
      catergorySelectedKeys: [],
      catergoryRemovedRecIds: [],
      catergoryNewValue: '',
      catergoryEditingRecId: null,
      catergoryMgmtLoading: false
    };
  }

  componentDidMount = async () => {
    console.log('PortfolioAdmin componentDidMount - This should load for Admin users!');
    console.log('PortfolioAdmin - isAuthenticated:', this.state.isAuthenticated);
    
    // Setup axios interceptors for session management
    setupAxiosInterceptors(axios);
    
    // Check if user is authenticated, if not redirect to login
    if (!this.state.isAuthenticated) {
      this.props.history.push('/login');
      return;
    }

    // Verify that the authentication data contains required information
    if (!Array.isArray(this.state.isAuthenticated) || !this.state.isAuthenticated[1]) {
      console.error('Invalid authentication data structure');
      this.props.history.push('/login');
      return;
    }

    try {
      // Get user email from authentication props
      const userEmail = this.state.isAuthenticated[1]; // Email is the second element in the array
      console.log('PortfolioAdmin: Loading data for user email:', userEmail);
      
      this.setState({ userEmail });
      await Promise.all([
        this.fetchRedemptionRecords(),
        this.fetchBookingRecords(),
        this.fetchMatchingFundPool(),
        this.fetchMatchSummary(),
        this.fetchStatusEmailState(),
        this.fetchRedemptionOptionLists(),
        this.loadAdminDataByEmail(userEmail),
      ]);
    } catch (error: any) {
      console.error('Error during authentication or data loading:', error);
      // If there's an authentication error, logout with session expired flag
      if (error.response && error.response.status === 401) {
        await sessionManager.logout(true);
        return;
      }
      this.setState({ loading: false });
    }
  };

  fetchMatchingFundPool = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/matchingfundpool?month=${this.state.redemptionMonth + 1}&year=${this.state.redemptionYear}`,
        this.getAuthHeaders(),
      );
      this.setState({
        dripTotal: Number(response.data?.dripTotal) || 0,
        newPurchaseTotal: Number(response.data?.newPurchaseTotal) || 0,
      });
    } catch (error) {
      console.error('Error fetching matching fund pool:', error);
      this.setState({ dripTotal: 0, newPurchaseTotal: 0 });
    }
  };

  saveMatchingFundPool = async (dripTotal: number, newPurchaseTotal: number) => {
    try {
      const response = await axios.put(
        `${baseURL}/matchingfundpool?month=${this.state.redemptionMonth + 1}&year=${this.state.redemptionYear}`,
        { dripTotal, newPurchaseTotal },
        this.getAuthHeaders(),
      );
      this.setState({
        dripTotal: Number(response.data?.dripTotal) || 0,
        newPurchaseTotal: Number(response.data?.newPurchaseTotal) || 0,
      });
      message.success('Matching fund pool updated.');
    } catch (error) {
      console.error('Error updating matching fund pool:', error);
      message.error('Unable to update matching fund pool.');
      throw error;
    }
  };

  // Build session auth headers
  getAuthHeaders = () => {
    const sessionToken = sessionManager.getSessionToken();
    return sessionToken
      ? { headers: { Authorization: `Bearer ${sessionToken}` } }
      : {};
  };

  // Catergories of one partner, read from the catergory/partnercatergory tables
  showPartnerCatergoryModal = async (partnerRecId: string, account: string) => {
    this.setState({
      isPartnerCatergoryModalOpen: true,
      partnerCatergoryRecId: partnerRecId,
      partnerCatergoryAccount: account || '',
      partnerCatergoryList: [],
      partnerCatergorySelectedKeys: [],
      partnerCatergoryLoading: true,
    });
    try {
      const response = await axios.get(
        `${baseURL}/partner/${encodeURIComponent(partnerRecId)}/catergories`,
        this.getAuthHeaders(),
      );
      const rows = Array.isArray(response.data) ? response.data : [];
      this.setState({
        partnerCatergoryList: rows,
        partnerCatergorySelectedKeys: rows
          .filter((row: any) => row.selected)
          .map((row: any) => row.recId),
        partnerCatergoryLoading: false,
      });
    } catch (error) {
      console.error('Error fetching partner catergories:', error);
      message.error('Unable to load catergories for this account.');
      this.setState({ partnerCatergoryLoading: false });
    }
  };

  handlePartnerCatergoryCancel = () => {
    this.setState({
      isPartnerCatergoryModalOpen: false,
      partnerCatergoryList: [],
      partnerCatergorySelectedKeys: [],
    });
  };

  handlePartnerCatergoryOk = async () => {
    this.setState({ partnerCatergoryLoading: true });
    try {
      await axios.put(
        `${baseURL}/partner/${encodeURIComponent(this.state.partnerCatergoryRecId)}/catergories`,
        { categoryRecIds: this.state.partnerCatergorySelectedKeys },
        this.getAuthHeaders(),
      );
      message.success('Catergories saved.');
      this.setState({
        isPartnerCatergoryModalOpen: false,
        partnerCatergoryList: [],
        partnerCatergorySelectedKeys: [],
        partnerCatergoryLoading: false,
      });
    } catch (error: any) {
      console.error('Error saving partner catergories:', error);
      message.error(error?.response?.data?.message || 'Unable to save catergories.');
      this.setState({ partnerCatergoryLoading: false });
    }
  };

  // Catergories management: edits are staged locally and only sent on OK
  showCatergoryMgmtModal = async () => {
    this.setState({
      isCatergoryMgmtModalOpen: true,
      catergoryRows: [],
      catergorySelectedKeys: [],
      catergoryRemovedRecIds: [],
      catergoryNewValue: '',
      catergoryEditingRecId: null,
      catergoryMgmtLoading: true,
    });
    await this.fetchCatergoryRows();
  };

  fetchCatergoryRows = async () => {
    try {
      const response = await axios.get(`${baseURL}/catergory`, this.getAuthHeaders());
      const rows = Array.isArray(response.data) ? response.data : [];
      this.setState({
        catergoryRows: rows.map((row: any) => ({
          recId: row.recId,
          description: row.description || '',
        })),
        catergoryMgmtLoading: false,
      });
    } catch (error) {
      console.error('Error fetching catergories:', error);
      message.error('Unable to load catergories.');
      this.setState({ catergoryMgmtLoading: false });
    }
  };

  handleCatergoryMgmtCancel = () => {
    this.setState({
      isCatergoryMgmtModalOpen: false,
      catergoryRows: [],
      catergorySelectedKeys: [],
      catergoryRemovedRecIds: [],
      catergoryNewValue: '',
      catergoryEditingRecId: null,
    });
  };

  handleCatergoryNewValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ catergoryNewValue: e.target.value });
  };

  handleCatergoryEditSelected = () => {
    const recId = this.state.catergorySelectedKeys[0];
    const row = this.state.catergoryRows.find((r) => r.recId === recId);
    if (!row) {
      message.warning('Select exactly one row to edit.');
      return;
    }
    this.setState({
      catergoryEditingRecId: row.recId,
      catergoryNewValue: row.description,
    });
  };

  handleCatergoryCancelEdit = () => {
    this.setState({ catergoryEditingRecId: null, catergoryNewValue: '' });
  };

  // Shared by Add and by saving an in-progress edit
  handleCatergorySubmitValue = () => {
    const value = (this.state.catergoryNewValue || '').trim();
    if (!value) {
      message.warning('Enter a catergory value first.');
      return;
    }
    const editingRecId = this.state.catergoryEditingRecId;
    const duplicate = this.state.catergoryRows.some(
      (row) =>
        row.recId !== editingRecId &&
        row.description.trim().toLowerCase() === value.toLowerCase(),
    );
    if (duplicate) {
      message.warning(`"${value}" already exists.`);
      return;
    }

    if (editingRecId) {
      this.setState({
        catergoryRows: this.state.catergoryRows.map((row) =>
          row.recId === editingRecId
            ? { ...row, description: value, isEdited: !row.isNew }
            : row,
        ),
        catergoryNewValue: '',
        catergoryEditingRecId: null,
        catergorySelectedKeys: [],
      });
      return;
    }

    this.setState({
      catergoryRows: [
        ...this.state.catergoryRows,
        {
          recId: `new-${Date.now()}-${this.state.catergoryRows.length}`,
          description: value,
          isNew: true,
        },
      ],
      catergoryNewValue: '',
    });
  };

  handleCatergoryDeleteSelected = () => {
    const selected = new Set(this.state.catergorySelectedKeys);
    if (selected.size === 0) {
      message.warning('Select at least one row to delete.');
      return;
    }
    const removedRecIds = this.state.catergoryRows
      .filter((row) => selected.has(row.recId) && !row.isNew)
      .map((row) => row.recId);
    const editingRecId = this.state.catergoryEditingRecId;
    this.setState({
      catergoryRows: this.state.catergoryRows.filter((row) => !selected.has(row.recId)),
      catergoryRemovedRecIds: [...this.state.catergoryRemovedRecIds, ...removedRecIds],
      catergorySelectedKeys: [],
      catergoryEditingRecId: editingRecId && selected.has(editingRecId) ? null : editingRecId,
      catergoryNewValue:
        editingRecId && selected.has(editingRecId) ? '' : this.state.catergoryNewValue,
    });
  };

  handleCatergoryMgmtOk = async () => {
    const { catergoryRemovedRecIds, catergoryRows, catergoryEditingRecId } = this.state;
    if (catergoryEditingRecId) {
      message.warning('Save or cancel the row you are editing first.');
      return;
    }

    const additions = catergoryRows.filter((row) => row.isNew);
    const updates = catergoryRows.filter((row) => row.isEdited && !row.isNew);
    if (
      catergoryRemovedRecIds.length === 0 &&
      additions.length === 0 &&
      updates.length === 0
    ) {
      this.handleCatergoryMgmtCancel();
      return;
    }

    this.setState({ catergoryMgmtLoading: true });
    try {
      // Deletes and renames run before inserts so a freed-up value can be reused.
      for (const recId of catergoryRemovedRecIds) {
        await axios.delete(
          `${baseURL}/catergory/${encodeURIComponent(recId)}`,
          this.getAuthHeaders(),
        );
      }
      for (const row of updates) {
        await axios.put(
          `${baseURL}/catergory/${encodeURIComponent(row.recId)}`,
          { description: row.description },
          this.getAuthHeaders(),
        );
      }
      for (const row of additions) {
        await axios.post(
          `${baseURL}/catergory`,
          { description: row.description },
          this.getAuthHeaders(),
        );
      }
      message.success('Catergories saved.');
      this.setState({
        isCatergoryMgmtModalOpen: false,
        catergoryRows: [],
        catergorySelectedKeys: [],
        catergoryRemovedRecIds: [],
        catergoryNewValue: '',
        catergoryEditingRecId: null,
        catergoryMgmtLoading: false,
      });
    } catch (error: any) {
      console.error('Error saving catergories:', error);
      message.error(error?.response?.data?.message || 'Unable to save catergories.');
      // Some calls may already have applied, so resync from the server.
      this.setState({ catergoryRemovedRecIds: [], catergorySelectedKeys: [] });
      await this.fetchCatergoryRows();
    }
  };

  // Fetch redemption request records for the selected month/year (Admin = all rows)
  fetchRedemptionRecords = async () => {
    this.setState({ redemptionLoading: true });
    try {
      const month = this.state.redemptionMonth + 1; // backend expects 1-based month
      const year = this.state.redemptionYear;
      const response = await axios.get(
        `${baseURL}/redemptionrequest/list?month=${month}&year=${year}`,
        this.getAuthHeaders(),
      );
      const records = response.data || [];
      const localNewRows = (this.state.redemptionRecords || []).filter(
        (row: any) =>
          typeof row?.recId === 'string' && row.recId.startsWith('new-'),
      );
      const mergedRecords = [...records];
      localNewRows.forEach((row: any) => {
        if (!mergedRecords.some((r: any) => r.recId === row.recId)) {
          mergedRecords.push(row);
        }
      });

      this.setState({
        redemptionRecords: mergedRecords,
        redemptionLoading: false,
      });
    } catch (error) {
      console.error('Error fetching redemption records:', error);
      const localNewRows = (this.state.redemptionRecords || []).filter(
        (row: any) =>
          typeof row?.recId === 'string' && row.recId.startsWith('new-'),
      );
      const mergedRecords = [...localNewRows];
      this.setState({
        redemptionRecords: mergedRecords,
        redemptionLoading: false,
      });
    }
  };

  // Fetch option lists for the editable relation columns (reuse existing endpoints)
  fetchRedemptionOptionLists = async () => {
    try {
      const [partnersRes, advisorsRes, emdsRes] = await Promise.all([
        axios.get(`${baseURL}/partner`, this.getAuthHeaders()),
        axios.get(`${baseURL}/emd/advisors`, this.getAuthHeaders()),
        axios.get(`${baseURL}/emd`, this.getAuthHeaders()),
      ]);
      const buildName = (p: any) =>
        (p.fullName && p.fullName.trim()) ||
        [p.firstName, p.lastName].filter(Boolean).join(' ').trim() ||
        p.email ||
        p.recId;
      this.setState({
        partnerOptions: (partnersRes.data || []).map((p: any) => ({
          recId: p.recId,
          name: buildName(p),
        })),
        advisorOptions: (advisorsRes.data || []).map((a: any) => ({
          recId: a.recId,
          name: buildName(a),
        })),
        emdOptions: (emdsRes.data || []).map((e: any) => ({
          recId: e.recId,
          name: e.firm || e.recId,
        })),
      });
    } catch (error) {
      console.error('Error fetching redemption option lists:', error);
    }
  };

  handleRedemptionPeriodChange = (month: number, year: number) => {
    this.setState({ redemptionMonth: month, redemptionYear: year }, () => {
      this.fetchRedemptionRecords();
      this.fetchMatchingFundPool();
      this.fetchMatchSummary();
      this.fetchStatusEmailState();
    });
  };

  fetchMatchSummary = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/redemptionrequest/match-summary?month=${this.state.redemptionMonth + 1}&year=${this.state.redemptionYear}`,
        this.getAuthHeaders(),
      );
      this.setState({
        totalMatch: Number(response.data?.totalMatch) || 0,
        totalNonMatch: Number(response.data?.totalNonMatch) || 0,
        totalRetracted: Number(response.data?.totalRetracted) || 0,
        matchedCount: Number(response.data?.matchedCount) || 0,
        matchPeriodAllocated: Number(response.data?.matchPeriodAllocated) || 0,
      });
    } catch (error) {
      console.error('Error fetching redemption match summary:', error);
      this.setState({
        totalMatch: 0,
        totalNonMatch: 0,
        totalRetracted: 0,
        matchedCount: 0,
        matchPeriodAllocated: 0,
      });
    }
  };

  // Tracks whether the selected period's status update email has already gone
  // out, so the button can be disabled instead of sending twice.
  fetchStatusEmailState = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/redemptionrequest/status-email?month=${this.state.redemptionMonth + 1}&year=${this.state.redemptionYear}`,
        this.getAuthHeaders(),
      );
      this.setState({
        statusEmailSent: !!response.data?.sent,
        statusEmailSentAt: response.data?.sentAt || null,
      });
    } catch (error) {
      console.error('Error fetching redemption status email state:', error);
      this.setState({ statusEmailSent: false, statusEmailSentAt: null });
    }
  };

  sendStatusUpdateEmail = async () => {
    if (this.state.sendingStatusEmail || this.state.statusEmailSent) return;
    this.setState({ sendingStatusEmail: true });
    try {
      const response = await axios.post(
        `${baseURL}/redemptionrequest/send-status-email?month=${this.state.redemptionMonth + 1}&year=${this.state.redemptionYear}`,
        {},
        this.getAuthHeaders(),
      );
      const failed = response.data?.failedRecipients || [];
      message.success(
        `Status update email sent to ${response.data?.sentCount || 0} recipient(s).`,
      );
      if (failed.length) {
        message.warning(`Could not reach: ${failed.join(', ')}`);
      }
      await this.fetchStatusEmailState();
    } catch (error: any) {
      console.error('Error sending redemption status update email:', error);
      message.error(
        error?.response?.data?.message || 'Unable to send the status update email.',
      );
      if (error?.response?.status === 409) await this.fetchStatusEmailState();
    } finally {
      this.setState({ sendingStatusEmail: false });
    }
  };

  matchRedemptions = async () => {
    if (this.state.matching || this.state.completingMatches) return;
    this.setState({ matching: true });
    try {
      const response = await axios.post(
        `${baseURL}/redemptionrequest/match?month=${this.state.redemptionMonth + 1}&year=${this.state.redemptionYear}`,
        {},
        this.getAuthHeaders(),
      );
      message.success(`${response.data?.matchedCount || 0} redemption request(s) matched.`);
      await Promise.all([this.fetchRedemptionRecords(), this.fetchMatchSummary()]);
    } catch (error) {
      console.error('Error matching redemption requests:', error);
      message.error('Unable to match redemption requests.');
    } finally {
      this.setState({ matching: false });
    }
  };

  markMatchesComplete = async () => {
    if (this.state.matching || this.state.completingMatches) return;
    this.setState({ completingMatches: true });
    try {
      const response = await axios.post(
        `${baseURL}/redemptionrequest/mark-complete?month=${this.state.redemptionMonth + 1}&year=${this.state.redemptionYear}`,
        {},
        this.getAuthHeaders(),
      );
      message.success(`${response.data?.completedCount || 0} redemption request(s) completed.`);
      await Promise.all([this.fetchRedemptionRecords(), this.fetchMatchSummary()]);
    } catch (error) {
      console.error('Error completing matched redemption requests:', error);
      message.error('Unable to mark redemption requests complete.');
    } finally {
      this.setState({ completingMatches: false });
    }
  };

  saveRedemptionRow = async (recId: string, patch: any): Promise<boolean> => {
    const current =
      (this.state.redemptionRecords || []).find((r: any) => r.recId === recId) || {};
    const merged = { ...current, ...patch };
    const isNewRow = recId.startsWith('new-');

    // New/static rows are not yet persisted -> create them via POST. Existing DB
    // rows are updated via PUT. Both then refetch so the table reflects the DB.
    if (isNewRow) {
      if (!merged.account) {
        message.warning('Please enter an Account before saving.');
        // Keep the in-progress edits locally so the user can complete them.
        this.updateRedemptionRowLocally(recId, patch);
        return false;
      }
      try {
        const payload: any = {
          account: (merged.account || '').toString().trim(),
          fullName: (merged.clientName || '').toString().trim(),
          advisorName: (merged.advisorName || '').toString().trim(),
          emdFirm: (merged.emdFirm || '').toString().trim(),
          status: (merged.status || 'Pending').toString(),
        };

        const clientId = this.asValidUuid(merged.clientId);
        const advisorId = this.asValidUuid(merged.advisorId);
        const emdId = this.asValidUuid(merged.emdId);
        if (clientId) payload.clientId = clientId;
        if (advisorId) payload.advisorId = advisorId;
        if (emdId) payload.emdId = emdId;

        const amount = this.parseMoney(merged.amount);
        if (Number.isFinite(amount)) {
          payload.amount = amount;
        }

        const queueNumber = Number(merged.queueNumber);
        if (Number.isInteger(queueNumber) && queueNumber >= 0) {
          payload.queueNumber = queueNumber;
        }

        if (!payload.fullName) {
          message.warning('Please enter Client Name before saving.');
          this.updateRedemptionRowLocally(recId, patch);
          return false;
        }

        const dateRequest = (merged.dateRequest || '').toString().trim();
        // DTO uses @IsDateString; normalize to a full ISO string.
        if (dateRequest) {
          if (/^\d{4}-\d{2}-\d{2}$/.test(dateRequest)) {
            payload.dateRequest = moment(dateRequest, 'YYYY-MM-DD', true)
              .startOf('day')
              .toISOString();
          } else {
            const parsed = new Date(dateRequest);
            if (!Number.isNaN(parsed.getTime())) {
              payload.dateRequest = parsed.toISOString();
            }
          }
        }

        await axios.post(
          `${baseURL}/redemptionrequest`,
          payload,
          this.getAuthHeaders(),
        );
        message.success('Redemption request created');
        this.setState((prev) => ({
          redemptionRecords: prev.redemptionRecords.filter((row: any) => row.recId !== recId),
        } as Pick<AdminState, 'redemptionRecords'>));
        await Promise.all([
          this.fetchRedemptionRecords(),
          this.fetchMatchSummary(),
        ]);
        return true;
      } catch (error: any) {
        console.error('Error creating redemption request:', {
          status: error?.response?.status,
          data: error?.response?.data,
          requestPayload: {
            account: (merged.account || '').toString().trim(),
            clientId: merged.clientId,
            advisorId: merged.advisorId,
            advisorName: merged.advisorName,
            emdId: merged.emdId,
            emdFirm: merged.emdFirm,
            amount: merged.amount,
            dateRequest: merged.dateRequest,
            queueNumber: merged.queueNumber,
            status: merged.status,
          },
        });
        const backendMessage =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          'Failed to create redemption request';
        message.error(
          Array.isArray(backendMessage) ? backendMessage.join('; ') : backendMessage,
        );
        this.updateRedemptionRowLocally(recId, patch);
        return false;
      }
    }

    try {
      const updatePayload: any = { ...patch };

      if (updatePayload.advisorName !== undefined) {
        updatePayload.advisorName = updatePayload.advisorName.toString().trim();
      }

      if (updatePayload.amount !== undefined) {
        const parsedAmount = this.parseMoney(updatePayload.amount);
        if (Number.isFinite(parsedAmount)) {
          updatePayload.amount = parsedAmount;
        } else {
          delete updatePayload.amount;
        }
      }

      if (updatePayload.dateRequest !== undefined) {
        const dateRequest = updatePayload.dateRequest.toString().trim();
        if (!dateRequest) {
          delete updatePayload.dateRequest;
        } else if (/^\d{4}-\d{2}-\d{2}$/.test(dateRequest)) {
          updatePayload.dateRequest = moment(dateRequest, 'YYYY-MM-DD', true)
            .startOf('day')
            .toISOString();
        } else {
          const parsed = new Date(dateRequest);
          if (!Number.isNaN(parsed.getTime())) {
            updatePayload.dateRequest = parsed.toISOString();
          } else {
            delete updatePayload.dateRequest;
          }
        }
      }

      await axios.put(
        `${baseURL}/redemptionrequest/${recId}`,
        updatePayload,
        this.getAuthHeaders(),
      );
      message.success('Redemption request updated');
      await Promise.all([
        this.fetchRedemptionRecords(),
        this.fetchMatchSummary(),
      ]);
      return true;
    } catch (error) {
      console.error('Error updating redemption request:', error);
      message.error('Failed to update redemption request');
      return false;
    }
  };

  // Applies an edit to a not-yet-persisted row locally so the user can keep editing.
  updateRedemptionRowLocally = (recId: string, patch: any) => {
    this.setState((prev) => ({
      redemptionRecords: prev.redemptionRecords.map((row: any) =>
        row.recId === recId ? { ...row, ...patch } : row,
      ),
    } as Pick<AdminState, 'redemptionRecords'>));
  };

  // Looks up the partner by the entered account and fills Client Name / Advisor / EMD.
  handleAccountLookup = async (recId: string, account: string) => {
    if (!account) return;
    try {
      const res = await axios.get(
        `${baseURL}/redemptionrequest/partner-by-account?account=${encodeURIComponent(account)}`,
        this.getAuthHeaders(),
      );
      const data = res.data || {};
      const lookupPatch = {
        account: data.account || account,
        clientId: data.partnerId || '',
        clientName: data.clientName || '',
        fullName: data.clientName || '',
        advisorId: data.advisorId || '',
        advisorName: data.advisorName || '',
        emdId: data.emdId || '',
        emdFirm: data.emdFirm || '',
      };
      this.setState((prev) => ({
        redemptionRecords: prev.redemptionRecords.map((row: any) =>
          row.recId === recId ? { ...row, ...lookupPatch } : row,
        ),
      } as Pick<AdminState, 'redemptionRecords'>));
      if (!lookupPatch.advisorName || !lookupPatch.emdFirm) {
        message.warning(
          'Client found, but this partner has no linked Advisor/EMD. The record can be saved and assigned later.',
        );
      }
      return lookupPatch;
    } catch (error: any) {
      if (error.response && error.response.status === 404) {
        message.warning('No partner found for this account.');
      } else {
        console.error('Error looking up partner by account:', error);
      }
      const emptyLookupPatch = {
        account,
        clientId: '',
        clientName: '',
        fullName: '',
        advisorId: '',
        advisorName: '',
        emdId: '',
        emdFirm: '',
      };
      this.setState((prev) => ({
        redemptionRecords: prev.redemptionRecords.map((row: any) =>
          row.recId === recId ? { ...row, ...emptyLookupPatch } : row,
        ),
      } as Pick<AdminState, 'redemptionRecords'>));
      return emptyLookupPatch;
    }
  };

  // Adds a new (local) blank row to the table and returns its id so it opens for editing.
  addRedemptionRow = (): string => {
    const newRecId = `new-${Date.now()}`;
    this.setState((prev) => {
      const maxQueue = prev.redemptionRecords.reduce(
        (max: number, r: any) => Math.max(max, r.queueNumber || 0),
        0,
      );
      const newRow = {
        recId: newRecId,
        clientId: '',
        advisorId: '',
        emdId: '',
        fullName: '',
        clientName: '',
        account: '',
        advisorName: '',
        emdFirm: '',
        amount: 0,
        dateRequest: moment().format('YYYY-MM-DD'),
        queueNumber: maxQueue + 1,
        status: 'Pending',
      };
      return {
        redemptionRecords: [...prev.redemptionRecords, newRow],
      } as Pick<AdminState, 'redemptionRecords'>;
    });
    return newRecId;
  };

  // Booking list: future-dated redemptions that the sweep promotes into the
  // redemption list one month before their scheduled month. Not month-filtered.
  fetchBookingRecords = async () => {
    this.setState({ bookingLoading: true });
    try {
      const response = await axios.get(
        `${baseURL}/redemptionbooking/list`,
        this.getAuthHeaders(),
      );
      const records = response.data || [];
      const localNewRows = (this.state.bookingRecords || []).filter(
        (row: any) =>
          typeof row?.recId === 'string' && row.recId.startsWith('new-'),
      );
      const mergedRecords = [...records];
      localNewRows.forEach((row: any) => {
        if (!mergedRecords.some((r: any) => r.recId === row.recId)) {
          mergedRecords.push(row);
        }
      });
      this.setState({ bookingRecords: mergedRecords, bookingLoading: false });
    } catch (error) {
      console.error('Error fetching redemption bookings:', error);
      const localNewRows = (this.state.bookingRecords || []).filter(
        (row: any) =>
          typeof row?.recId === 'string' && row.recId.startsWith('new-'),
      );
      this.setState({ bookingRecords: localNewRows, bookingLoading: false });
    }
  };

  updateBookingRowLocally = (recId: string, patch: any) => {
    this.setState((prev) => ({
      bookingRecords: prev.bookingRecords.map((row: any) =>
        row.recId === recId ? { ...row, ...patch } : row,
      ),
    } as Pick<AdminState, 'bookingRecords'>));
  };

  handleBookingAccountLookup = async (recId: string, account: string) => {
    if (!account) return;
    try {
      const res = await axios.get(
        `${baseURL}/redemptionrequest/partner-by-account?account=${encodeURIComponent(account)}`,
        this.getAuthHeaders(),
      );
      const data = res.data || {};
      const lookupPatch = {
        account: data.account || account,
        clientId: data.partnerId || '',
        clientName: data.clientName || '',
        fullName: data.clientName || '',
        advisorId: data.advisorId || '',
        advisorName: data.advisorName || '',
        emdId: data.emdId || '',
        emdFirm: data.emdFirm || '',
      };
      this.updateBookingRowLocally(recId, lookupPatch);
      if (!lookupPatch.advisorName || !lookupPatch.emdFirm) {
        message.warning(
          'Client found, but this partner has no linked Advisor/EMD. The booking can be saved and assigned later.',
        );
      }
      return lookupPatch;
    } catch (error: any) {
      if (error.response && error.response.status === 404) {
        message.warning('No partner found for this account.');
      } else {
        console.error('Error looking up partner by account:', error);
      }
      const emptyLookupPatch = {
        account,
        clientId: '',
        clientName: '',
        fullName: '',
        advisorId: '',
        advisorName: '',
        emdId: '',
        emdFirm: '',
      };
      this.updateBookingRowLocally(recId, emptyLookupPatch);
      return emptyLookupPatch;
    }
  };

  saveBookingRow = async (recId: string, patch: any): Promise<boolean> => {
    const current =
      (this.state.bookingRecords || []).find((r: any) => r.recId === recId) || {};
    const merged = { ...current, ...patch };
    const isNewRow = recId.startsWith('new-');

    const backendError = (error: any, fallback: string) => {
      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        fallback;
      message.error(
        Array.isArray(backendMessage) ? backendMessage.join('; ') : backendMessage,
      );
    };

    if (isNewRow) {
      if (!merged.account) {
        message.warning('Please enter an Account before saving.');
        this.updateBookingRowLocally(recId, patch);
        return false;
      }
      if (!merged.clientName) {
        message.warning('Please enter Client Name before saving.');
        this.updateBookingRowLocally(recId, patch);
        return false;
      }
      if (!merged.dateSchedule) {
        message.warning('Please select a Date Schedule before saving.');
        this.updateBookingRowLocally(recId, patch);
        return false;
      }

      try {
        const payload: any = {
          account: (merged.account || '').toString().trim(),
          fullName: (merged.clientName || '').toString().trim(),
          advisorName: (merged.advisorName || '').toString().trim(),
          emdFirm: (merged.emdFirm || '').toString().trim(),
          dateSchedule: moment(merged.dateSchedule).format('YYYY-MM'),
          status: (merged.status || 'Pending').toString(),
        };

        const clientId = this.asValidUuid(merged.clientId);
        const advisorId = this.asValidUuid(merged.advisorId);
        const emdId = this.asValidUuid(merged.emdId);
        if (clientId) payload.clientId = clientId;
        if (advisorId) payload.advisorId = advisorId;
        if (emdId) payload.emdId = emdId;

        const amount = this.parseMoney(merged.amount);
        if (Number.isFinite(amount)) {
          payload.amount = amount;
        }

        // queueNumber is left to the server, which numbers per scheduled month.

        const dateRequest = (merged.dateRequest || '').toString().trim();
        if (dateRequest) {
          const parsed = /^\d{4}-\d{2}-\d{2}$/.test(dateRequest)
            ? moment(dateRequest, 'YYYY-MM-DD', true).startOf('day').toDate()
            : new Date(dateRequest);
          if (!Number.isNaN(parsed.getTime())) {
            payload.dateRequest = parsed.toISOString();
          }
        }

        await axios.post(
          `${baseURL}/redemptionbooking`,
          payload,
          this.getAuthHeaders(),
        );
        message.success('Booking created');
        this.setState((prev) => ({
          bookingRecords: prev.bookingRecords.filter(
            (row: any) => row.recId !== recId,
          ),
        } as Pick<AdminState, 'bookingRecords'>));
        await this.fetchBookingRecords();
        return true;
      } catch (error: any) {
        console.error('Error creating redemption booking:', error);
        backendError(error, 'Failed to create booking');
        this.updateBookingRowLocally(recId, patch);
        return false;
      }
    }

    try {
      const updatePayload: any = { ...patch };
      delete updatePayload.clientName;

      if (updatePayload.advisorName !== undefined) {
        updatePayload.advisorName = updatePayload.advisorName.toString().trim();
      }

      if (updatePayload.amount !== undefined) {
        const parsedAmount = this.parseMoney(updatePayload.amount);
        if (Number.isFinite(parsedAmount)) {
          updatePayload.amount = parsedAmount;
        } else {
          delete updatePayload.amount;
        }
      }

      if (updatePayload.dateSchedule !== undefined) {
        const dateSchedule = updatePayload.dateSchedule.toString().trim();
        if (!dateSchedule) {
          delete updatePayload.dateSchedule;
        } else {
          updatePayload.dateSchedule = moment(dateSchedule).format('YYYY-MM');
        }
      }

      await axios.put(
        `${baseURL}/redemptionbooking/${recId}`,
        updatePayload,
        this.getAuthHeaders(),
      );
      message.success('Booking updated');
      await this.fetchBookingRecords();
      return true;
    } catch (error: any) {
      console.error('Error updating redemption booking:', error);
      backendError(error, 'Failed to update booking');
      return false;
    }
  };

  addBookingRow = (): string => {
    const newRecId = `new-${Date.now()}`;
    const now = new Date();
    const floor = new Date(
      Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 2, 1),
    );
    const dateSchedule = `${floor.getUTCFullYear()}-${String(floor.getUTCMonth() + 1).padStart(2, '0')}`;
    this.setState((prev) => {
      // Queue numbers restart at 1 in each scheduled month.
      const maxQueue = prev.bookingRecords
        .filter(
          (r: any) =>
            moment(r.dateSchedule).format('YYYY-MM') === dateSchedule,
        )
        .reduce((max: number, r: any) => Math.max(max, r.queueNumber || 0), 0);
      const newRow = {
        recId: newRecId,
        clientId: '',
        advisorId: '',
        emdId: '',
        fullName: '',
        clientName: '',
        account: '',
        advisorName: '',
        emdFirm: '',
        amount: 0,
        dateRequest: moment().format('YYYY-MM-DD'),
        dateSchedule,
        queueNumber: maxQueue + 1,
        status: 'Pending',
      };
      return {
        bookingRecords: [...prev.bookingRecords, newRow],
      } as Pick<AdminState, 'bookingRecords'>;
    });
    return newRecId;
  };

  deleteBookingRow = async (recId: string): Promise<boolean> => {
    if (recId.startsWith('new-')) {
      this.setState((prev) => ({
        bookingRecords: prev.bookingRecords.filter(
          (row: any) => row.recId !== recId,
        ),
      } as Pick<AdminState, 'bookingRecords'>));
      return true;
    }
    try {
      await axios.delete(
        `${baseURL}/redemptionbooking/${recId}`,
        this.getAuthHeaders(),
      );
      message.success('Booking deleted');
      await this.fetchBookingRecords();
      return true;
    } catch (error: any) {
      console.error('Error deleting redemption booking:', error);
      const backendMessage =
        error?.response?.data?.message || 'Failed to delete booking';
      message.error(
        Array.isArray(backendMessage) ? backendMessage.join('; ') : backendMessage,
      );
      return false;
    }
  };

  // Aggregates the visible redemption records into per-EMD-firm totals for the
  // progress ring (each firm becomes a differently coloured segment).
  getRedemptionByFirm = (): Array<{ firm: string; amount: number }> => {    const totals: { [firm: string]: number } = {};
    (this.state.redemptionRecords || [])
      .filter((r: any) =>
        r.status === 'Matched' ||
        r.status === 'Completed' ||
        r.status === 'Redeemed',
      )
      .forEach((r: any) => {
      const firm = r.emdFirm || 'Unknown';
      totals[firm] = (totals[firm] || 0) + (Number(r.amount) || 0);
      });
    return Object.keys(totals).map((firm) => ({ firm, amount: totals[firm] }));
  };

  getTotalRedemption = (): number =>
    getActiveRedemptionTotal(this.state.redemptionRecords || []);

  // Validate session with server
  validateSessionWithServer = async (): Promise<boolean> => {
    try {
      const response = await axios.post(`${baseURL}/auth/validate-session`);
      return response.data.valid;
    } catch (error) {
      console.error('Session validation failed:', error);
      return false;
    }
  };

  // Get user email from session data
  getUserEmailFromSession = (): string | null => {
    try {
      // Try to get user email from stored session data
      const sessionData = localStorage.getItem('ginkgo_session');
      if (sessionData) {
        const parsed = JSON.parse(sessionData);
        if (parsed.user && parsed.user.email) {
          return parsed.user.email;
        }
      }
      
      // Fallback: make a request to get current user info
      // This will be handled by the session validation above
      return null;
    } catch (error) {
      console.error('Error getting user email from session:', error);
      return null;
    }
  };

  // Handle session expiry - called when session expires
  handleSessionExpiry = async () => {
    this.setState({ 
      isAuthenticated: false,
      userEmail: null 
    });
    await sessionManager.logout(true);
  };

  loadAdminDataByEmail = async (userEmail: string) => {
    this.setState({ loading: true });
    
    try {
      // Use Promise.all to load admin data in parallel using the user's email
      const [summaryResponse, emdFirmsResponse, adminInfoResponse] = await Promise.all([
        axios.get(`${baseURL}/admin/summary`),
        axios.get(`${baseURL}/admin/emd-firms`),
        axios.get(`${baseURL}/admin/by-email/${encodeURIComponent(userEmail)}`)
      ]);
      
      console.log('summaryResponse:', summaryResponse.data);
      console.log('emdFirmsResponse:', emdFirmsResponse.data);
      console.log('adminInfoResponse:', adminInfoResponse.data);
      
      const adminSummary = summaryResponse.data || {
        totalEMDFirms: 0,
        totalAdvisors: 0,
        totalClients: 0,
        totalAssets: '$0.00',
        emdSummary: []
      };
      
      const emdFirms = emdFirmsResponse.data || [];
      const adminInfo = adminInfoResponse.data || null;
      
      this.setState({ 
        adminSummary,
        emdFirms,
        adminInfo
      });

      // Automatically select the EMD firm with the highest total assets
      if (emdFirms && emdFirms.length > 0) {
        const emdWithHighestAssets = emdFirms.reduce((maxEMD: any, currentEMD: any) => {
          const maxAssets = parseFloat(maxEMD.totalAssets?.replace(/[$,]/g, '') || '0');
          const currentAssets = parseFloat(currentEMD.totalAssets?.replace(/[$,]/g, '') || '0');
          return currentAssets > maxAssets ? currentEMD : maxEMD;
        });
        
        console.log('EMD with highest assets selected:', emdWithHighestAssets);
        
        // Set the selected EMD
        this.setState({
          selectedEMDId: emdWithHighestAssets.emdId,
          selectedEMD: emdWithHighestAssets
        });
        
        // Load the EMD dashboard data for the selected firm
        await this.loadEMDDashboardData(emdWithHighestAssets.emdId);
      }

    } catch (error) {
      console.error('Error loading admin data by email:', error);
      // Set empty data on error
      this.setState({ 
        adminSummary: {
          totalEMDFirms: 0,
          totalAdvisors: 0,
          totalClients: 0,
          totalAssets: '0.00',
          emdSummary: []
        },
        emdFirms: [],
        adminInfo: null
      });
    }
    
    this.setState({ loading: false });
  };

  // EMD Firm List Modal handlers
  showEMDListModal = () => {
    this.setState({ isEMDListModalOpen: true });
  };

  handleEMDListCancel = () => {
    this.setState({ 
      isEMDListModalOpen: false,
      emdSearchText: ''
    });
  };

  handleEMDSearch = (value: string) => {
    this.setState({ emdSearchText: value });
  };

  // Redemption Report Modal handlers
  showRedemptionReportModal = () => {
    this.setState({ isRedemptionReportModalOpen: true });
  };

  handleRedemptionReportCancel = () => {
    this.setState({ isRedemptionReportModalOpen: false });
  };

  handleRedemptionMonthChange = (value: string) => {
    this.setState({ selectedReportMonth: value });
  };

  // Commission Report Modal handlers
  showCommissionReportModal = () => {
    this.setState({ isCommissionReportModalOpen: true });
  };

  handleCommissionReportCancel = () => {
    this.setState({ isCommissionReportModalOpen: false });
  };

  handleCommissionMonthChange = (value: string) => {
    this.setState({ selectedCommissionMonth: value });
  };

  // T5/NR4 Report Modal handlers
  showT5NR4ReportModal = () => {
    this.setState({ isT5NR4ReportModalOpen: true });
  };

  handleT5NR4ReportCancel = () => {
    this.setState({ isT5NR4ReportModalOpen: false });
  };

  handleT5NR4YearChange = (value: string) => {
    this.setState({ selectedT5NR4Year: value });
  };

  handleT5NR4ProductChange = (value: string) => {
    this.setState({ selectedT5NR4Product: value });
  };

  handleT5NR4AccNumChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ selectedT5NR4AccNum: e.target.value });
  };

  // VIP List Modal handlers
  showVIPListModal = () => {
    this.setState({ isVIPListModalOpen: true });
  };

  handleVIPListCancel = () => {
    this.setState({ isVIPListModalOpen: false });
  };

  handleVIPProvinceChange = (value: string) => {
    this.setState({ selectedVIPProvince: value });
  };

  handleVIPMinValueChange = (value: string) => {
    this.setState({ selectedVIPMinValue: value });
  };

  generateVIPList = async () => {
    const { selectedVIPProvince, selectedVIPMinValue } = this.state;
    
    if (!selectedVIPMinValue) {
      alert('Please select a minimum principal value');
      return;
    }

    try {
      this.setState({ loading: true });
      
      console.log('Generating VIP list:', { province: selectedVIPProvince, minValue: selectedVIPMinValue });
      
      const response = await axios.get(`${baseURL}/gettopinvestortotalvalue`, {
        params: {
          value: selectedVIPMinValue,
          province: selectedVIPProvince
        },
        headers: {
          'Accept': 'application/json'
        }
      });

      console.log('VIP List Response:', response.data);

      // Convert JSON data to CSV format
      const jsonData = response.data;
      let csvContent = '';
      
      if (Array.isArray(jsonData) && jsonData.length > 0) {
        const headers = Object.keys(jsonData[0]);
        csvContent = headers.join(',') + '\n';
        
        jsonData.forEach(row => {
          const values = headers.map(header => {
            let value = row[header];
            if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
              return `"${value.replace(/"/g, '""')}"`;
            }
            return value || '';
          });
          csvContent += values.join(',') + '\n';
        });
      } else {
        csvContent = 'No VIP data available for the selected criteria\n';
      }
      
      // Create blob and download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `VIP_List_${selectedVIPProvince || 'All'}_${selectedVIPMinValue.replace('$', '')}.csv`;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

      console.log('VIP list file download initiated successfully');
      this.setState({ isVIPListModalOpen: false });
      
    } catch (error) {
      console.error('Error generating VIP list:', error);
      alert('Error generating VIP list. Please try again.');
    } finally {
      this.setState({ loading: false });
    }
  };

  pingSalesforceMcp = async () => {
    try {
      this.setState({ loading: true });

      const response = await axios.get(`${baseURL}/mcp/salesforce/ping`, {
        headers: {
          Accept: 'application/json',
        },
      });

      const resultText =
        response?.data?.result?.content?.[0]?.text ||
        JSON.stringify(response.data);

      Modal.success({
        title: 'Salesforce MCP Ping Success',
        content: (
          <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{resultText}</pre>
        ),
      });
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        'Unable to reach Salesforce MCP server.';

      Modal.error({
        title: 'Salesforce MCP Ping Failed',
        content: message,
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  querySalesforceMcpUser = async () => {
    try {
      this.setState({ loading: true });

      const response = await axios.get(`${baseURL}/mcp/salesforce/query-user`, {
        headers: {
          Accept: 'application/json',
        },
      });

      this.setState({
        mcpQueryFirstRecord: response?.data?.firstRecord || null,
      });

      if (!response?.data?.firstRecord) {
        Modal.info({
          title: 'Salesforce MCP Query',
          content: 'Query completed but no records were returned.',
        });
      }
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        'Unable to run Salesforce MCP query.';

      Modal.error({
        title: 'Salesforce MCP Query Failed',
        content: message,
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  // Advisor List Modal handlers
  showAdvisorListModal = () => {
    this.setState({ isAdvisorListModalOpen: true });
  };

  handleAdvisorListCancel = () => {
    this.setState({ 
      isAdvisorListModalOpen: false,
      advisorSearchText: ''
    });
  };

  handleAdvisorSearch = (value: string) => {
    this.setState({ advisorSearchText: value });
  };

  // Resolve the advisor recId currently in context for the admin dashboard
  getSelectedAdvisorRecId = (): string => {
    const { selectedAdvisor, selectedAdvisorId, advisorId } = this.state;
    return (
      selectedAdvisor?.recId ||
      selectedAdvisor?.advisorId ||
      selectedAdvisorId ||
      advisorId ||
      ''
    );
  };

  // Parse a money value that may arrive as "$1,234.56", 1234.56 or null
  parseMoney = (value: any): number => {
    if (value === null || value === undefined) return 0;
    const parsed = parseFloat(String(value).replace(/[$,\s]/g, ''));
    return isNaN(parsed) ? 0 : parsed;
  };

  // Backend DTO validates UUID fields strictly. Static/sample rows can carry
  // non-UUID placeholders, so omit those fields on create.
  asValidUuid = (value: any): string | undefined => {
    if (typeof value !== 'string') return undefined;
    const v = value.trim();
    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidRegex.test(v) ? v : undefined;
  };

  // Build the client rows for an advisor. Totals arrive with the list, so no
  // per-client request is needed.
  buildClientRows = (partners: any[]) => {
    const rows: { key: number; firstName: string; lastName: string; emailAddress: string; phone: string; totalValue: string; totalDrip: string; tin: string }[] = [];

    for (let i = 0; i < partners.length; i++) {
      const partner = partners[i];
      if (!partner || !partner.tin) continue;

      if (this.parseMoney(partner.clientTotalValue) > 0) {
        // active client
        rows.push({
          key: i,
          firstName: partner.firstName,
          lastName: partner.advisorType === 'IBP' ? partner.lastName + ' *IBP' : partner.lastName,
          emailAddress: partner.emailAddress || '',
          phone: partner.phoneHome || '',
          totalValue: partner.clientTotalValue ?? '0',
          totalDrip: partner.clientTotalDrip ?? '0',
          tin: partner.tin,
        });
      }
    }

    return rows;
  };

  // Load the client list for the advisor currently selected on the dashboard
  loadClientList = async (advisorRecId: string) => {
    if (!advisorRecId) {
      console.error('No advisor selected - cannot load client list');
      return;
    }

    this.setState({ clientListLoading: true });

    try {
      const clients = await axios.get(baseURL + '/partner/clientList?advisorId=' + advisorRecId);
      const partners = clients.data?.partners || [];

      this.setState({
        advisorId: advisorRecId,
        clientListData: partners,
        clientTotalValue: clients.data?.clientTotalValue || 0,
        totalClient: partners.length,
      });

      const rows = this.buildClientRows(partners);
      this.setState({ clientList: rows });
    } catch (error) {
      console.error('Error loading client list:', error);
      message.error('Unable to load the client list for the selected advisor.');
    } finally {
      this.setState({ clientListLoading: false });
    }
  };

  // Client List Modal handlers
  showClientListModal = async () => {
    this.setState({ isModalOpen: true });
    await this.loadClientList(this.getSelectedAdvisorRecId());
  };

  handleClientListCancel = () => {
    this.setState({ isModalOpen: false });
  };

  handleClientListSearch = (value: string) => {
    this.setState({ searchText: value });
  };

  renderClientListTable = () => {
    const columns = [
      {
        title: 'First Name',
        dataIndex: 'firstName',
        key: 'firstName',
        sorter: (a: any, b: any) => (a.firstName || '').localeCompare(b.firstName || ''),
      },
      {
        title: 'Last Name',
        dataIndex: 'lastName',
        sorter: (a: any, b: any) => (a.lastName || '').localeCompare(b.lastName || ''),
      },
      {
        title: 'Phone',
        dataIndex: 'phone',
      },
      {
        title: 'Email',
        dataIndex: 'emailAddress',
      },
      {
        title: 'Total Drip',
        dataIndex: 'totalDrip',
        key: 'totalDrip',
        render: (totalDrip: string) => {
          const numericValue = parseFloat(totalDrip?.replace(/[$,]/g, '') || '0');
          return `$${numericValue.toLocaleString()}`;
        },
        sorter: (a: any, b: any) => {
          const aValue = parseFloat(a.totalDrip?.replace(/[$,]/g, '') || '0');
          const bValue = parseFloat(b.totalDrip?.replace(/[$,]/g, '') || '0');
          return aValue - bValue;
        },
      },
      {
        title: 'Total Value',
        dataIndex: 'totalValue',
        key: 'totalValue',
        render: (totalValue: string) => {
          const numericValue = parseFloat(totalValue?.replace(/[$,]/g, '') || '0');
          return `$${numericValue.toLocaleString()}`;
        },
        sorter: (a: any, b: any) => {
          const aValue = parseFloat(a.totalValue?.replace(/[$,]/g, '') || '0');
          const bValue = parseFloat(b.totalValue?.replace(/[$,]/g, '') || '0');
          return aValue - bValue;
        },
      },
    ];

    const rowSelection = {
      onChange: (selectedRowKey: any, selectedRow: any) => {
        this.setState({selectedPartnerSin: selectedRow[0].tin});
      }
    };

    const data = this.state.clientList || [];
    const filteredData = data.filter((item) =>
      (item.lastName || '').toLowerCase().includes((this.state.searchText || '').toLowerCase()) ||
      (item.firstName || '').toLowerCase().includes((this.state.searchText || '').toLowerCase()) ||
      (item.emailAddress || '').toLowerCase().includes((this.state.searchText || '').toLowerCase())
    );

    return (
      <Table 
        columns={columns} 
        dataSource={filteredData} 
        size="small" 
        rowSelection={{type: "radio", ...rowSelection}}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
        loading={this.state.clientListLoading}
        scroll={{ y: 400 }}
      />
    );
  };

  handleClientListOk = async () => {
    console.log('selected partner sin:', this.state.selectedPartnerSin);

    // Use Promise.all for initial data loading
    const [partners] = await Promise.all([
      axios.get(baseURL+"/advisoraccounts?advisorId=" + this.state.advisorId + '&partnerSin=' + this.state.selectedPartnerSin)
    ]);
    
    this.setState({
      isModalOpen: false,
    });
    
    console.log('return partners:', partners.data);
    this.setState({selectedYear: moment().dayOfYear(1).format(dateFormat)})
    this.sumFeesTotalOnYears(partners.data[0].recId, this.state.certificateProductName)
    await this.getAccountTrailerFeesTotal(partners.data[0].recId, '')
    this.sumFeesTotalOnYears(partners.data[0].recId, this.state.certificateProductName)
    
    this.setState({partner: partners.data[0], partnersData: partners.data, currentAccountRecId: partners.data[0].recId, displayAccountNum: partners.data[0].account, displayAdvisorType: partners.data[0].advisorType })
    
    // Use Promise.all for data fetching
    const [cert_data, comm_data] = await Promise.all([
      this.getCertData(this.state.certStartDate, this.state.certEndDate, partners.data[0].recId, this.state.certificateProductId),
      axios.get(baseURL+"/commissiondetails?partnerId="+partners.data[0].recId+'&productName='+'')
    ]);
    
    this.setState({ certData: cert_data.data, commData: comm_data.data});
    await this.countTotalAccountsValue(partners.data.map((partnerData:any)=>(partnerData.recId)))
  };

  // All Client List: every advisor's clients, grouped one row per client (tin)
  loadAllClientList = async (
    search: string,
    page: number,
    pageSize?: number,
    sort?: { field: string | null; order: 'ascend' | 'descend' | null },
  ) => {
    const nextPageSize = pageSize || this.state.allClientPageSize;
    const sortField = sort ? sort.field : this.state.allClientSortField;
    const sortOrder = sort ? sort.order : this.state.allClientSortOrder;
    const hasSort = Boolean(sortField && sortOrder);
    this.setState({ allClientListLoading: true });

    try {
      const params: any = {
        search: search || '',
        limit: nextPageSize,
        offset: (page - 1) * nextPageSize,
      };
      // Sorting is done server-side so it spans every matching client, not just this page.
      if (hasSort) {
        params.sortField = sortField;
        params.sortOrder = sortOrder;
      }
      const response = await axios.get(baseURL + '/partner/allClientList', { params });

      this.setState({
        allClientList: response.data?.partners || [],
        allClientTotal: response.data?.total || 0,
        allClientPage: page,
        allClientPageSize: nextPageSize,
        allClientSortField: hasSort ? sortField : null,
        allClientSortOrder: hasSort ? sortOrder : null,
      });
    } catch (error) {
      console.error('Error loading all client list:', error);
      message.error('Unable to load the client list.');
    } finally {
      this.setState({ allClientListLoading: false });
    }
  };

  showAllClientListModal = async () => {
    this.setState({ isAllClientListModalOpen: true, selectedAllClient: null });
    await this.loadAllClientList(this.state.allClientSearchText, 1);
  };

  handleAllClientListCancel = () => {
    this.setState({ isAllClientListModalOpen: false });
  };

  handleAllClientSearch = async (value: string) => {
    this.setState({ allClientSearchText: value, selectedAllClient: null });
    await this.loadAllClientList(value, 1);
  };

  handleAllClientTableChange = async (pagination: any, _filters: any, sorter: any) => {
    const nextPageSize = pagination?.pageSize || this.state.allClientPageSize;
    const activeSorter = Array.isArray(sorter) ? sorter[0] : sorter;
    const field: string | null = activeSorter?.order
      ? String(activeSorter.columnKey ?? activeSorter.field ?? '') || null
      : null;
    const order: 'ascend' | 'descend' | null = field ? activeSorter.order : null;

    const sortChanged =
      field !== this.state.allClientSortField || order !== this.state.allClientSortOrder;
    const sizeChanged = nextPageSize !== this.state.allClientPageSize;
    const page = sortChanged || sizeChanged ? 1 : pagination?.current || 1;

    await this.loadAllClientList(this.state.allClientSearchText, page, nextPageSize, {
      field,
      order,
    });
  };

  renderAllClientListTable = () => {
    const serverSort = (key: string) => ({
      sorter: true,
      sortOrder: this.state.allClientSortField === key ? this.state.allClientSortOrder : null,
    });

    const columns = [
      {
        title: 'Account',
        key: 'accounts',
        render: (record: any) => {
          const accounts = (record.accounts || []).map((a: any) => a.account).filter(Boolean);
          if (accounts.length === 0) return '';
          const shown = accounts.slice(0, 2).join(', ');
          const label = accounts.length > 2 ? `${shown} (+${accounts.length - 2})` : shown;
          return <Tooltip title={accounts.join(', ')}>{label}</Tooltip>;
        },
        ...serverSort('accounts'),
      },
      {
        title: 'First Name',
        dataIndex: 'firstName',
        key: 'firstName',
        ...serverSort('firstName'),
      },
      {
        title: 'Last Name',
        key: 'lastName',
        render: (record: any) =>
          record.advisorType === 'IBP' ? `${record.lastName || ''} *IBP` : record.lastName || '',
        ...serverSort('lastName'),
      },
      {
        title: 'Phone',
        dataIndex: 'phoneHome',
        key: 'phoneHome',
      },
      {
        title: 'Email',
        dataIndex: 'emailAddress',
        key: 'emailAddress',
      },
      {
        title: 'Advisor',
        key: 'advisorName',
        render: (record: any) => (
          <span>
            {record.advisorName || ''}
            {record.advisorCount > 1 && (
              <span style={{ color: '#888', fontSize: '12px' }}> (multiple advisors)</span>
            )}
          </span>
        ),
        ...serverSort('advisorName'),
      },
      {
        title: 'EMD Firm',
        dataIndex: 'emdFirm',
        key: 'emdFirm',
      },
      {
        title: 'Total Drip',
        dataIndex: 'clientTotalDrip',
        key: 'clientTotalDrip',
        render: (totalDrip: string) => `$${this.parseMoney(totalDrip).toLocaleString()}`,
        ...serverSort('clientTotalDrip'),
      },
      {
        title: 'Total Value',
        dataIndex: 'clientTotalValue',
        key: 'clientTotalValue',
        render: (totalValue: string) => `$${this.parseMoney(totalValue).toLocaleString()}`,
        ...serverSort('clientTotalValue'),
      },
    ];

    const rowSelection = {
      selectedRowKeys: this.state.selectedAllClient ? [this.state.selectedAllClient.tin] : [],
      onChange: (selectedRowKeys: any, selectedRows: any) => {
        this.setState({ selectedAllClient: selectedRows[0] || null });
      },
    };

    return (
      <Table
        columns={columns}
        dataSource={(this.state.allClientList || []).map((client: any) => ({
          ...client,
          key: client.tin,
        }))}
        size="small"
        rowSelection={{ type: 'radio', ...rowSelection }}
        pagination={{
          current: this.state.allClientPage,
          pageSize: this.state.allClientPageSize,
          total: this.state.allClientTotal,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
        onChange={this.handleAllClientTableChange}
        loading={this.state.allClientListLoading}
        scroll={{ y: 400 }}
      />
    );
  };

  handleAllClientListOk = async () => {
    const client = this.state.selectedAllClient;
    if (!client) {
      message.warning('Please select a client.');
      return;
    }

    this.setState({ allClientListLoading: true });

    try {
      // No advisor filter: list every account under the client's tin, whichever advisor holds it.
      const partners = await axios.get(baseURL + '/advisoraccounts', {
        params: { advisorId: '', partnerSin: client.tin },
      });

      if (!partners.data || partners.data.length === 0) {
        message.warning('No accounts found for this client.');
        return;
      }

      const firstAccount = partners.data[0];

      this.setState({
        isAllClientListModalOpen: false,
        advisorId: client.advisorRecId || '',
        selectedAdvisorId: client.advisorRecId || '',
        selectedPartnerSin: client.tin,
        selectedYear: moment().dayOfYear(1).format(dateFormat),
        partner: firstAccount,
        partnersData: partners.data,
        currentAccountRecId: firstAccount.recId,
        displayAccountNum: firstAccount.account,
        displayAdvisorType: firstAccount.advisorType,
      });

      await this.getAccountTrailerFeesTotal(firstAccount.recId, '');
      await this.sumFeesTotalOnYears(firstAccount.recId, this.state.certificateProductName);

      const [cert_data, transaction_data, redeem_data, comm_data] = await Promise.all([
        this.getCertData(
          this.state.certStartDate,
          this.state.certEndDate,
          firstAccount.recId,
          this.state.certificateProductId,
        ),
        this.getTransactionData(
          this.state.transactionStartDate,
          this.state.transactionEndDate,
          firstAccount.recId,
          this.state.transactionProductId,
        ),
        this.getRedeemData(firstAccount.recId),
        axios.get(baseURL + '/commissiondetails?partnerId=' + firstAccount.recId + '&productName='),
      ]);

      this.setState({
        certData: cert_data.data,
        transactionData: transaction_data.data,
        redeemData: redeem_data.data || [],
        commData: comm_data.data,
      });

      await this.countTotalAccountsValue(partners.data.map((partnerData: any) => partnerData.recId));
    } catch (error) {
      console.error('Error loading the selected client:', error);
      message.error('Unable to load the selected client.');
    } finally {
      this.setState({ allClientListLoading: false });
    }
  };


 /*  handleTagChange = (event: any) => {
    const recId = event.target.id;
    const selectedPartner = this.state.partnersData.find((partner: any) => partner.recId === recId);
    if (selectedPartner) {
      this.setState({
        currentAccountRecId: recId,
        displayAccountNum: selectedPartner.account,
        displayAdvisorType: selectedPartner.advisorType,
        partner: selectedPartner
      });
    }
  };
 */
  handleTagChange = async (e: any) => {
  
  let currentAccountRecId = e.target.id;
  this.setState( (prevState:any)=> ({ ...prevState, currentAccountRecId }));
  const currentPartnerInfo = this.state.partnersData.filter((partner:any)=>partner.recId === currentAccountRecId);
  
  // Use Promise.all to coordinate multiple async operations
  const [transaction_data, redeem_data, cert_data] = await Promise.all([
    this.getTransactionData(this.state.transactionStartDate, this.state.transactionEndDate, currentAccountRecId, this.state.transactionProductId),
    this.getRedeemData(currentAccountRecId),
    this.getCertData(this.state.certStartDate, this.state.certEndDate, currentAccountRecId, this.state.certificateProductId)
  ]);
  
  this.setState({ transactionData: transaction_data.data, certData: cert_data.data, redeemData: redeem_data.data, displayAccountNum: currentPartnerInfo[0].account});
  await this.getCommissionData(currentAccountRecId, this.state.certificateProductName)
  this.setState({ displayAccountNum: currentPartnerInfo[0].account, displayAdvisorType: currentPartnerInfo[0].advisorType, partner: currentPartnerInfo[0] });
  await this.sumFeesTotalOnYears(currentAccountRecId, this.state.certificateProductName)
};

  getCommissionData = async(partnerId:any, productName:any) => {
    const commQuery = '?partnerId='+partnerId+'&productName='+productName
    
    // Use Promise.all for consistency
    const [comm_data] = await Promise.all([
      axios.get(baseURL+"/commissiondetails"+commQuery)
    ]);
    
    this.setState({ commData: comm_data.data});
  }

  // Select EMD firm from modal
  selectEMDFromModal = async (emdFirm: any) => {
    this.setState({ 
      selectedEMDId: emdFirm.emdId,
      selectedEMD: emdFirm,
      isEMDListModalOpen: false,
      emdSearchText: '',
      loading: true,
      // Clear previous advisor and client data when selecting new EMD
      selectedAdvisor: null,
      selectedAdvisorId: null,
      clientList: [],
      clientListData: [],
      partner: null,
      partnersData: [],
      totalAccountValue: [],
      certData: [],
      transactionData: [],
      redeemData: [],
      commData: [],
      currentAccountRecId: '',
      displayAccountNum: '',
      displayAdvisorType: '',
      totalClient: 0,
      totalAsset: 0,
      totalAccountsValue: 0,
      totalAccountsTrailerFees: 0
    });
    
    try {
      // Load the selected EMD's data
      await this.loadEMDDashboardData(emdFirm.emdId);
      
      console.log('EMD selected and data loaded:', emdFirm);
    } catch (error) {
      console.error('Error loading EMD data after selection:', error);
    } finally {
      this.setState({ loading: false });
    }
  };

  // Select advisor from modal
  selectAdvisorFromModal = async (advisor: any) => {
    this.setState({ 
      selectedAdvisorId: advisor.recId || advisor.advisorId,
      selectedAdvisor: advisor,
      isAdvisorListModalOpen: false,
      advisorSearchText: '',
      loading: true,
      // Clear all previous client data
      partner: null,
      partnersData: [],
      clientList: [],
      clientListData: [],
      selectedPartnerSin: '',
      currentAccountRecId: '',
      displayAccountNum: '',
      displayAdvisorType: '',
      totalAccountValue: [],
      totalAccountsValue: 0,
      totalAccountsTrailerFees: 0,
      certData: [],
      transactionData: [],
      redeemData: [],
      commData: [],
      certSub_total: 0,
      totalClient: 0,
      totalAsset: 0
    });
    
    try {
      // Load the selected advisor's data including client list
      if (advisor.email) {
        await this.loadAdvisorData(this.state.userEmail!, advisor.email);
      }
      
      console.log('Advisor selected and data loaded:', advisor);
    } catch (error) {
      console.error('Error loading advisor data after selection:', error);
    } finally {
      this.setState({ loading: false });
    }
  };

  loadEMDDashboardData = async (emdId: string) => {
    try {
      // Get EMD firm details which includes advisors and summary
      const [emdDetails] = await Promise.all([
        axios.get(`${baseURL}/admin/emd-firms/${emdId}`)
      ]);

      console.log('EMD Details:', emdDetails.data);

      const { emdInfo, summary, advisors } = emdDetails.data;
      
      this.setState({
        emdInfo,
        emdSummary: {
          totalAdvisors: summary.totalAdvisors,
          totalClients: summary.totalClients,
          totalAssets: summary.totalAssets,
          advisorSummary: summary.advisorSummary
        },
        advisors: advisors || []
      });

      // Automatically select the advisor with the most clients if available
      if (advisors && advisors.length > 0) {
        const advisorWithMostClients = advisors.reduce((maxAdvisor: any, currentAdvisor: any) => {
          const maxClientCount = maxAdvisor.totalClient || 0;
          const currentClientCount = currentAdvisor.totalClient || 0;
          return currentClientCount > maxClientCount ? currentAdvisor : maxAdvisor;
        });
        
        this.setState({ 
          selectedAdvisorId: advisorWithMostClients.recId,
          selectedAdvisor: advisorWithMostClients
        });
        
        console.log('Advisor with most clients selected:', advisorWithMostClients);
        
        // Load the selected advisor's data including client list
        if (advisorWithMostClients.email) {
          await this.loadAdvisorData(this.state.userEmail!, advisorWithMostClients.email);
        }
      }

    } catch (error) {
      console.error('Error loading EMD dashboard data:', error);
    }
  };

  // Load advisor data (reused from EMD dashboard)
  loadAdvisorData = async (userEmail: string, advisorEmail: string) => {
    // Check if advisor email is provided
    if (!advisorEmail) {
      console.error('No advisor email provided');
      return;
    }

    let partnersQuery = ''
    console.log('Loading advisor data for user:', userEmail, 'and advisor:', advisorEmail);
    
    try {
      const user = await axios.get(baseURL + '/user/' + userEmail)
      const advisor = await axios.get(baseURL + '/advisor/' + advisorEmail)
      this.setState({userId: user.data.id, userType: user.data.userType, advisorId: advisor.data.recId})
      console.log('Advisor ID:', this.state.advisorId, 'User ID:', this.state.userId);
      
      const clientFirstTin = await axios.get(baseURL + '/partnertin?advisorId='+advisor.data.recId)
      partnersQuery = '?advisorId='+ advisor.data.recId + '&partnerSin=' + clientFirstTin.data
      const partners = await axios.get(baseURL+"/advisoraccounts"+partnersQuery)
      
      try {
        if (partners.data && partners.data.length > 0) {
          this.setState({selectedYear: moment().dayOfYear(1).format(dateFormat)})
          this.sumFeesTotalOnYears(partners.data[0].recId, this.state.certificateProductName)
          await this.getAccountTrailerFeesTotal(partners.data[0].recId, '')
          this.sumFeesTotalOnYears(partners.data[0].recId, this.state.certificateProductName)
          const cert_data = await this.getCertData(this.state.certStartDate, this.state.certEndDate, partners.data[0].recId, this.state.certificateProductId);
          const transaction_data = await this.getTransactionData(this.state.transactionStartDate, this.state.transactionEndDate, partners.data[0].recId,this.state.transactionProductId);
          const redeem_data = await this.getRedeemData(partners.data[0].recId);
          this.setState({ transactionData: transaction_data.data, certData: cert_data.data, redeemData: redeem_data.data || ''});
          this.setState({partner: partners.data[0], partnersData: partners.data, currentAccountRecId: partners.data[0].recId, displayAccountNum: partners.data[0].account, displayAdvisorType: partners.data[0].advisorType})
          const commQuery = '?partnerId='+partners.data[0].recId+'&productName='+''
          let comm_data = await axios.get(baseURL+"/commissiondetails"+commQuery)
          this.setState({commData: comm_data.data, selectedYear: moment().dayOfYear(1).format(dateFormat) });
          await this.countTotalAccountsValue(partners.data.map((partnerData:any)=>(partnerData.recId)))
          const advisorCommData = await axios.get(baseURL+'/advisorcommission?email=' + advisorEmail + '&theMonth=' + this.state.selectedCommMonth + '&theYear=' + this.state.selectedCommYear)
          this.setState({ commDataAdvisor: advisorCommData.data})
        }
      } catch (accountError) {
        // Account level detail failures must not prevent the client list from loading
        console.error('Error loading account details for advisor:', advisorEmail, accountError);
      }

      const clientsTotalAssets = await axios.post(baseURL+'/advisor/totals?advisorId='+ advisor.data.recId, {})
      this.setState({totalAsset: clientsTotalAssets.data.totalAssets || 0})

      await this.loadClientList(advisor.data.recId)

      const totalValue = await axios.get(baseURL+'/advisorcommissiontotalbymonth?email=' + advisorEmail + '&theMonth=' + this.state.selectedCommMonth + '&theYear=' + this.state.selectedCommYear)
      this.setState({currentMonthFeesTotal: totalValue.data || ''})
    } catch (error) {
      console.error('Error loading advisor data:', error);
      // Clear client data on error
      this.setState({
        clientListData: [],
        clientList: [],
        totalClient: 0,
        totalAsset: 0
      });
    }
  }

  // Render EMD firm list table for modal
  renderEMDListTable = () => {
    const { emdFirms, emdSearchText } = this.state;
    
    // Filter EMD firms based on search text
    const filteredEMDFirms = emdFirms.filter(emd => 
      emd.firm?.toLowerCase().includes(emdSearchText.toLowerCase()) ||
      emd.contactEmail?.toLowerCase().includes(emdSearchText.toLowerCase()) ||
      emd.contactFirstname?.toLowerCase().includes(emdSearchText.toLowerCase()) ||
      emd.contactLastname?.toLowerCase().includes(emdSearchText.toLowerCase())
    );

    const columns = [
      {
        title: 'Firm Name',
        dataIndex: 'firm',
        key: 'firm',
        sorter: (a: any, b: any) => (a.firm || '').localeCompare(b.firm || ''),
      },
      {
        title: 'Contact Name',
        key: 'contactName',
        render: (record: any) => `${record.contactFirstname || ''} ${record.contactLastname || ''}`,
        sorter: (a: any, b: any) => `${a.contactFirstname || ''} ${a.contactLastname || ''}`.localeCompare(`${b.contactFirstname || ''} ${b.contactLastname || ''}`),
      },
      {
        title: 'Email',
        dataIndex: 'contactEmail',
        key: 'contactEmail',
      },
      {
        title: 'Advisors',
        dataIndex: 'advisorCount',
        key: 'advisorCount',
        sorter: (a: any, b: any) => (a.advisorCount || 0) - (b.advisorCount || 0),
      },
      {
        title: 'Clients',
        dataIndex: 'clientCount',
        key: 'clientCount',
        sorter: (a: any, b: any) => (a.clientCount || 0) - (b.clientCount || 0),
      },
      {
        title: 'Total Assets',
        dataIndex: 'totalAssets',
        key: 'totalAssets',
        render: (totalAssets: string) => {
          const numericValue = parseFloat(totalAssets?.replace(/[$,]/g, '') || '0');
          return `$${numericValue.toLocaleString()}`;
        },
        sorter: (a: any, b: any) => {
          const aValue = parseFloat(a.totalAssets?.replace(/[$,]/g, '') || '0');
          const bValue = parseFloat(b.totalAssets?.replace(/[$,]/g, '') || '0');
          return aValue - bValue;
        },
      },
      {
        title: 'Action',
        key: 'action',
        render: (record: any) => (
          <Button
            type="primary" 
            disabled={!record.advisorCount || record.advisorCount === 0}
            onClick={() => this.selectEMDFromModal(record)}
          >
            Select
          </Button>
        ),
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={filteredEMDFirms.map((emd, index) => ({
          ...emd,
          key: emd.emdId || index
        }))}
        pagination={{ pageSize: 8 }}
        loading={this.state.loading}
        scroll={{ y: 400 }}
      />
    );
  };

  // Admin Summary Tab
  renderAdminSummaryTab = () => {
    const { selectedEMD, emdFirms } = this.state;

    return (
      <div>
        {selectedEMD && (
          <div style={{ marginBottom: 24 }}>
            <Title level={4} style={{ textAlign: 'center', marginBottom: 16 }}>
              Selected EMD Firm Information
            </Title>
            <Row gutter={16}>
              <Col span={6}>
                <Card>
                  <Statistic
                    title="EMD Firm"
                    value={selectedEMD.firm || 'N/A'}
                    prefix={<BuildOutlined />}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card>
                  <Statistic
                    title="Total Advisors"
                    value={selectedEMD.advisorCount || 0}
                    prefix={<BankOutlined />}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card>
                  <Statistic
                    title="Total Clients"
                    value={selectedEMD.clientCount || 0}
                    prefix={<TeamOutlined />}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card>
                  <Statistic
                    title="Total Assets"
                    value={parseFloat(selectedEMD.totalAssets?.replace(/[$,]/g, '') || '0')}
                    prefix={<DollarCircleOutlined />}
                    formatter={(value) => `$${value?.toLocaleString()}`}
                  />
                </Card>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  };

  // Include all the EMD dashboard methods from portfolioEMD.tsx
  // (All the methods like sumFeesTotalOnYears, getAccountTrailerFeesTotal, etc. would be included here)
  // For brevity, I'm including key ones:

  sumFeesTotalOnYears = async (recId:any, productName:any) => {
    let totalFeesOnYear = this.state.subTotalFeesOnYears
    
    await Promise.all(totalFeesOnYear.map(async (item:any) => {
     let commQuery = '?partnerId='+recId+'&year=yearB'+(Number(moment().year())-Number(item.year)).toString()+'&productName='+productName
     let commission = await axios.get(baseURL+"/commission"+commQuery)
     item.total = commission.data.total
    }))
    
    this.setState({subTotalFeesOnYears: totalFeesOnYear})
    this.copyYearsTotal(totalFeesOnYear)
  }

  copyYearsTotal = (totalArray:any) => {
      const  fiveYearsTotalArray:any = totalArray.filter((item:any) => item.year >= moment(this.state.selectedYear).subtract(4, "years").year() && item.year <= moment(this.state.selectedYear).year())
      const fiveYearsTotalValue= fiveYearsTotalArray.map((item:any) => item.total)
      this.setState({selectedYearCommTotal: fiveYearsTotalValue })
    }

  getAccountTrailerFeesTotal = async(recId:any, productName:any) => {
    const commQuery = '?partnerId='+recId+'&productName='+productName
    
    const [accountTrailerFees] = await Promise.all([
      axios.get(baseURL+"/trailerfees"+commQuery)
    ]);
    
    if (accountTrailerFees.data.yearstotal===null) {
      return 0
    }
    else {
      return parseFloat(accountTrailerFees.data.yearstotal.replace(/[^0-9.-]+/g,""))
    }
  }

  getTransactionData = async(transactionStartDate: string, transactionEndDate: string, recId: string, product: string) => {
    const transactionQuery = '?transactionStartDate='+transactionStartDate+'&transactionEndDate='+transactionEndDate+'&recId='+recId+'&productId='+product;
    
    const [transaction_data] = await Promise.all([
      axios.get(baseURL+"/transactions"+transactionQuery)
    ]);
    
    return transaction_data
  }

  getCertData = async(certStartDate: string, certEndDate: string, recId:string, product: string) => {
    const certQuery = '?certStartDate='+certStartDate+'&certEndDate='+certEndDate+'&recId='+recId+'&productId='+product;;
    
    const [cert_data] = await Promise.all([
      axios.get(baseURL+"/certificates"+certQuery)
    ]);
    
    let certSubtotal = 0
    if (cert_data.data.length!==0) {
      cert_data.data.forEach((cert:any)=> {
      // A certificate can have no linked transaction rows (e.g. while the
      // transaction table is being re-synced) - skip instead of throwing.
      if (cert.transaction && cert.transaction.length > 0) {
        certSubtotal += Number(cert.transaction[0].shares)
      }
    })}
      this.setState({certSub_total: Number(certSubtotal.toFixed(2))})
    return cert_data
  }

  getRedeemData = async(recId: string) => {	
    const [redeem_data] = await Promise.all([
      axios.get(baseURL+"/redeemrecord/?recId="+recId)
    ]);
    
    return redeem_data
  }
  
  onFinishCert = async (values: any) => {
    const { 'range-picker': rangePicker, 'product-select': productSelect } = values;
    
    let startDate = this.state.certStartDate;
    let endDate = this.state.certEndDate;
    let productId = this.state.certificateProductId;

    // Use range picker values directly - this is called when Search button is clicked
    // Format must be MM-DD-YYYY to match the backend API expectation
    if (rangePicker && rangePicker.length === 2) {
      startDate = rangePicker[0].format('MM-DD-YYYY');
      endDate = rangePicker[1].format('MM-DD-YYYY');
    }

    if (productSelect) {
      if (productSelect === 'GINKGO-S1') {
        productId = '253a1dc7-3bdc-40d9-98c9-75ca619fb035';
      } else if (productSelect === 'GINKGO-S2') {
        productId = '4097eb52-bcd6-4f56-b470-5b44e2bf6c54';
      } else {
        productId = '';
      }
    }
    const cert_data = await this.getCertData(startDate, endDate, this.state.currentAccountRecId, productId);
    this.setState({ 
      certData: cert_data.data, 
      certStartDate: startDate,
      certEndDate: endDate,
      certificateProductId: productId
    });
  }

  	delay(milliseconds:any){
		return new Promise(resolve => {
		setTimeout(resolve, milliseconds);
		});
	}

  onClickCertYear = async (e:any) => {
    switch (e.target.value) {
      case 'currentYear':
        this.setState({ certStartDate: moment().dayOfYear(1).format('MM-DD-YYYY'), certEndDate: moment().format('MM-DD-YYYY') });
        break;
      case 'latestTwoYears':
        this.setState({ certStartDate: moment().dayOfYear(1).subtract(1, 'years').format('MM-DD-YYYY'), certEndDate: moment().format('MM-DD-YYYY') });
        break;
      case 'allYears':
        this.setState({ certStartDate: moment().dayOfYear(1).subtract(9, 'years').format('MM-DD-YYYY'), certEndDate: moment().format('MM-DD-YYYY') });
        break;			
      case 'GINKGO-S1':
        this.setState({ certificateProductId: '253a1dc7-3bdc-40d9-98c9-75ca619fb035' });
        break;
      case 'GINKGO-S2':
        this.setState({ certificateProductId: '4097eb52-bcd6-4f56-b470-5b44e2bf6c54' });
        break;
      case 'All':
        this.setState({ certificateProductId: '' });
        break;
  }
    await this.delay(500)
    // Use Promise.all to wait for async operations
    const [cert_data] = await Promise.all([
      this.getCertData(this.state.certStartDate, this.state.certEndDate, this.state.currentAccountRecId, this.state.certificateProductId)
    ]);
    
    this.setState({ certData: cert_data.data});
  };

  onFinishTransaction = async (values: any) => {
    const {
      'transaction-range-picker': rangePicker,
      'transaction-year-select': yearSelect,
      'transaction-product-select': productSelect,
    } = values;
    
    let startDate = this.state.transactionStartDate;
    let endDate = this.state.transactionEndDate;
    let productId = this.state.transactionProductId;

    const hasRangeSelection = Array.isArray(rangePicker) && rangePicker.length === 2;

    // If both a quick year filter and a manual range are present, prefer the
    // manually selected range from the picker.
    if (yearSelect && !hasRangeSelection) {
      const currentYear = moment().year();
      if (yearSelect === 'currentYear') {
        startDate = `01-01-${currentYear}`;
        endDate = `12-31-${currentYear}`;
      } else if (yearSelect === 'latestTwoYears') {
        startDate = `01-01-${currentYear - 1}`;
        endDate = `12-31-${currentYear}`;
      } else if (yearSelect === 'allYears') {
        startDate = '01-01-2000';
        endDate = moment().format('MM-DD-YYYY');
      }
    }

    if (hasRangeSelection) {
      // Backend /api/transactions parses MM-DD-YYYY.
      startDate = rangePicker[0].format('MM-DD-YYYY');
      endDate = rangePicker[1].format('MM-DD-YYYY');
    }

    if (productSelect) {
      if (productSelect === 'GINKGO-S1') {
        productId = '253a1dc7-3bdc-40d9-98c9-75ca619fb035';
      } else if (productSelect === 'GINKGO-S2') {
        productId = '4097eb52-bcd6-4f56-b470-5b44e2bf6c54';
      } else {
        productId = '';
      }
    }
    const transaction_data = await this.getTransactionData(startDate, endDate, this.state.currentAccountRecId, productId);
    this.setState({ 
      transactionData: transaction_data.data,
      transactionStartDate: startDate,
      transactionEndDate: endDate,
      transactionProductId: productId
    });
  }

  onClickTransactionYear = async (e:any) => {
    switch (e.target.value) {
      case 'currentYear':
        this.setState({ transactionStartDate: moment().dayOfYear(1).format('MM-DD-YYYY'), transactionEndDate: moment().format('MM-DD-YYYY') });
        break;
      case 'latestTwoYears':
        this.setState({ transactionStartDate: moment().dayOfYear(1).subtract(1, 'years').format('MM-DD-YYYY'), transactionEndDate: moment().format('MM-DD-YYYY') });
        break;
      case 'allYears':
        this.setState({ transactionStartDate:  moment().dayOfYear(1).subtract(9, 'years').format('MM-DD-YYYY'), transactionEndDate:  moment().format('MM-DD-YYYY') });
        break;			
      case 'GINKGO-S1':
        this.setState({ transactionProductId: '253a1dc7-3bdc-40d9-98c9-75ca619fb035' });
        break;
      case 'GINKGO-S2':
        this.setState({ transactionProductId: '4097eb52-bcd6-4f56-b470-5b44e2bf6c54' });
        break;
      case 'All':
        this.setState({ transactionProductId: '' });
        break;
          }
    await this.delay(500)
    // Use Promise.all to wait for all async operations to complete
    const [transaction_data] = await Promise.all([
      this.getTransactionData(this.state.transactionStartDate, this.state.transactionEndDate, this.state.currentAccountRecId, this.state.transactionProductId)
    ]);
    this.setState({ transactionData: transaction_data.data});
  //	this.render();
  };


  countTotalAccountsValue = async(recIds:string[]) => {
    const totalAccountValueArray = await Promise.all(recIds.map(async (recId:string) => {
      return await this.getAccountPortfolio(recId)
    }));
    let totalAccountsValue = 0;
     let allAccountsTrailerFees = 0
    totalAccountValueArray.forEach((value)=>{
      allAccountsTrailerFees += value.totalAccountTrailerFees  
      if(value.accountTotal){
        totalAccountsValue += value.accountTotal;
      }
    })
    this.setState({totalAccountsValue: parseFloat(totalAccountsValue.toFixed(2)), totalAccountsTrailerFees: parseFloat(allAccountsTrailerFees.toFixed(2))});
    this.setState({totalAccountValue: totalAccountValueArray})
  }

  getAccountPortfolio = async(recId: string) => {
    const partnerInfo = this.state.partnersData.filter((partner:any)=>partner.recId === recId);
    
    const [totalFees, portfolio] = await Promise.all([
      this.getAccountTrailerFeesTotal(recId, ''),
      axios.get(baseURL+'/partnerportfolio?recId='+recId)
    ]);
    
    const portfolioPartner = portfolio?.data?.partner || {};
    return {
      total_share_S1_balance: portfolioPartner.shareS1 || 0,
      total_share_S2_balance: portfolioPartner.shareS2 || 0,
      accountTotal: this.parseMoney(portfolioPartner.totalValue),
      totalAccountTrailerFees: totalFees || 0,
      partnerInfo: partnerInfo[0] || { recId, category: '', account: '' }
    }	
  }

  // Generate redemption report for all EMD firms
  generateRedemptionReport = async () => {
    const { selectedReportMonth } = this.state;
    
    if (!selectedReportMonth) {
      alert('Please select a month for the report');
      return;
    }

    try {
      this.setState({ loading: true });
      
      // Format reportDate as YYYY-MM-DD with the last day of the month
      const lastDayOfMonth = moment(selectedReportMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      
      console.log('Generating redemption report for all advisors:', { reportDate: lastDayOfMonth });
      
      const response = await axios.get(`${baseURL}/report/redeem/all`, {
        params: {
          reportDate: lastDayOfMonth.toString()
        },
        headers: {
          'Accept': 'application/json'
        }
      });

      console.log('Response received:', response);
      console.log('Response data:', response.data);

      // Check if we received valid JSON data
      if (!response.data || typeof response.data !== 'object') {
        console.error('Invalid response format:', response.data);
        alert('Invalid response format from server');
        return;
      }

      // Convert JSON data to CSV format for Excel
      const jsonData = response.data;
      let csvContent = '';
      
      if (Array.isArray(jsonData) && jsonData.length > 0) {
        // Create CSV header from object keys
        const headers = Object.keys(jsonData[0]);
        csvContent = headers.join(',') + '\n';
        
        // Add data rows
        jsonData.forEach(row => {
          const values = headers.map(header => {
            let value = row[header];
            
            // Keep FullName multi-line content within a single cell (no newline flattening)
            // Handle values that might contain commas, quotes, or newlines
            if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
              return `"${value.replace(/"/g, '""')}"`;
            }
            return value || '';
          });
          csvContent += values.join(',') + '\n';
        });
      } else {
        csvContent = 'No data available for the selected period\n';
      }
      
      // Create blob and download as Excel file
      const blob = new Blob([csvContent], { 
        type: 'text/csv;charset=utf-8;' 
      });
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `All_Advisors_Redemption_Report_${selectedReportMonth}.csv`;
      link.style.display = 'none';
      
      // Add to DOM, click, and remove
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

      console.log('File download initiated successfully');
      this.setState({ isRedemptionReportModalOpen: false });
      
    } catch (error) {
      console.error('Error generating redemption report:', error);
      alert('Error generating redemption report. Please try again.');
    } finally {
      this.setState({ loading: false });
    }
  };  
  // Generate commission report for all EMD firms
  generateCommissionReport = async () => {
    const { selectedCommissionMonth } = this.state;
    
    if (!selectedCommissionMonth) {
      alert('Please select a month for the report');
      return;
    }

    try {
      this.setState({ loading: true });
      
      // Format reportDate as YYYY-MM-DD with the last day of the month
      const lastDayOfMonth = moment(selectedCommissionMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      
      console.log('Generating commission report for all EMD firms:', { reportDate: lastDayOfMonth });
      
      const response = await axios.get(`${baseURL}/emd/report/commissions/all`, {
        params: {
          reportDate: lastDayOfMonth
        },
        headers: {
          'Accept': 'application/json'
        }
      });

      console.log('Response received:', response);
      console.log('Response data:', response.data);

      // Check if we received valid JSON data
      if (!response.data || typeof response.data !== 'object') {
        console.error('Invalid response format:', response.data);
        alert('Invalid response format from server');
        return;
      }

      // Convert JSON data to CSV format for Excel
      const jsonData = response.data;
      let csvContent = '';
      
      if (Array.isArray(jsonData) && jsonData.length > 0) {
        // Create CSV header from object keys and add commission and trailer fees columns
        const originalHeaders = Object.keys(jsonData[0]);
        const headers = [...originalHeaders, 'commission', 'trailerFees'];
        csvContent = headers.join(',') + '\n';
        
        // Add data rows
        jsonData.forEach(row => {
          const values = headers.map(header => {
            let value;
            
            if (header === 'commission') {
              // Calculate commission based on issuedDate = payoutDate
              const payType = row.payType;
              const issuedDate = row.issuedDate;
              const payoutDate = row.payoutDate;
              
              // Check if issuedDate equals payoutDate
              if (issuedDate === payoutDate) {
                value = row.amountPaid || '0';
              } else {
                value = '0';
              }
            } else if (header === 'trailerFees') {
              // Calculate trailer fees - when it's NOT a commission
              const payType = row.payType;
              const issuedDate = row.issuedDate;
              const payoutDate = row.payoutDate;
              
              // Check if issuedDate does not equal payoutDate (opposite of commission logic)
              if (!(issuedDate === payoutDate)) {
                value = row.amountPaid || '0';
              } else {
                value = '0';
              }
            } else {
              value = row[header];
            }
            
            // Keep accountName multi-line content within a single cell (no newline flattening)
            // Handle values that might contain commas, quotes, or newlines
            if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
              return `"${value.replace(/"/g, '""')}"`;
            }
            return value || '';
          });
          csvContent += values.join(',') + '\n';
        });
      } else {
        csvContent = 'No commission data available for the selected period\n';
      }
      
      // Create blob and download as CSV file
      const blob = new Blob([csvContent], { 
        type: 'text/csv;charset=utf-8;' 
      });
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `All_EMD_Firms_Commission_Report_${selectedCommissionMonth}.csv`;
      link.style.display = 'none';
      
      // Add to DOM, click, and remove
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

      console.log('Commission report file download initiated successfully');
      this.setState({ isCommissionReportModalOpen: false });
      
    } catch (error) {
      console.error('Error generating commission report:', error);
      alert('Error generating commission report. Please try again.');
    } finally {
      this.setState({ loading: false });
    }
  };

  // Generate T5/NR4 report for all EMD firms
  generateT5NR4Report = async () => {
    const { selectedT5NR4Year, selectedT5NR4Product, selectedT5NR4AccNum } = this.state;
    
    if (!selectedT5NR4Year) {
      alert('Please select a year');
      return;
    }
    if (!selectedT5NR4Product) {
      alert('Please select a product (S1 or S2)');
      return;
    }
    if (!selectedT5NR4AccNum) {
      alert('Please enter an account number');
      return;
    }

    this.setState({ loading: true });
    
    try {
      // Determine if this is NR4 based on account number starting with 'FOR'
      const isNR4 = selectedT5NR4AccNum.startsWith('FOR');
      
      // Fetch the tax record based on account type
      const taxRecordResponse = await axios.get(
        `${baseURL}/${isNR4 ? 'getNR4Record' : 'getTaxRecord'}?account=${selectedT5NR4AccNum}`
      );
      
      const taxRecords = taxRecordResponse.data;
      
      if (!taxRecords || taxRecords.length === 0) {
        alert('No tax record found for this account number');
        this.setState({ loading: false });
        return;
      }
      
      // Find the record matching the selected year and product
      const matchingRecord = taxRecords.find((record: any) => 
        record.taxYear === selectedT5NR4Year && record.product === selectedT5NR4Product
      );
      
      if (!matchingRecord) {
        alert(`No tax record found for year ${selectedT5NR4Year} and product ${selectedT5NR4Product}`);
        this.setState({ loading: false });
        return;
      }
      
      if (isNR4) {
        // Download NR4
        await this.downloadNR4({
          taxYear: matchingRecord.taxYear,
          recpCode: matchingRecord.recpCode || '1',
          recpCountryCode: matchingRecord.recpCountryCode,
          recpAccount: matchingRecord.recpAccount,
          recpId: matchingRecord.recpId,
          incomeCode: matchingRecord.incomeCode || '61',
          currencyCode: matchingRecord.currencyCode || 'CAD',
          grossIncome: matchingRecord.grossIncome,
          taxWithheld: matchingRecord.taxWithheld || 0,
          product: matchingRecord.product,
          exemptionCode: matchingRecord.exemptionCode || '',
          recpName: matchingRecord.recpName,
          street: matchingRecord.street,
          city: matchingRecord.city,
          province: matchingRecord.province,
          postCode: matchingRecord.postCode,
          payerName: 'Ginkgo Investment Mortgage Corporation',
          payerAddress: '243 Consumers Road, Suite 210, Toronto, ON M2J 4W8',
          payerCountryCode: 'CA',
          payerTaxId: process.env.PAYER_ACCOUNT_NUMBER || 'F731166'
        });
      } else {
        // Download T5
        await this.downloadT5({
          accountNum: matchingRecord.accountNum,
          intAmount: matchingRecord.intAmount,
          product: matchingRecord.product,
          sin: matchingRecord.sin,
          taxYear: matchingRecord.taxYear,
          firstName: matchingRecord.firstName,
          lastName: matchingRecord.lastName,
          initate: matchingRecord.initate,
          fullName: matchingRecord.fullName,
          street: matchingRecord.street,
          city: matchingRecord.city,
          province: matchingRecord.province,
          postCode: matchingRecord.postCode,
          businessNumber: matchingRecord.businessNumber,
          businessName: matchingRecord.businessName,
          accountType: matchingRecord.accountType,
          submmitCode: matchingRecord.submmitCode
        });
      }
      
      this.setState({ isT5NR4ReportModalOpen: false });
      console.log(`${isNR4 ? 'NR4' : 'T5'} report generated for:`, selectedT5NR4AccNum, selectedT5NR4Product, selectedT5NR4Year);
    } catch (error) {
      console.error('Error generating T5/NR4 report:', error);
      alert('Error generating T5/NR4 report. Please check the account number and try again.');
    } finally {
      this.setState({ loading: false });
    }
  };

  // Download T5 PDF
  downloadT5 = async (data: any) => {
    try {
      const url = 'https://ginkgowebsite.s3.us-east-2.amazonaws.com/t5-2024b.pdf';
      const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());
      const sinCode = (data.sin === '000000000') ? data.businessNumber : data.sin;
      const sin = await axios.get(baseURL + "/decodeSIN?sin=" + sinCode);
      // Load a PDFDocument from the existing PDF bytes
      const pdfDoc = await PDFDocument.load(existingPdfBytes, { ignoreEncryption: true });
      // Get form
      const form = pdfDoc.getForm();
      // Fill form fields
      form.getTextField('SIN').setText(sin.data.toString());
      form.getTextField('interest_amount').setText(data.intAmount.toString().replace('$', ''));
      form.getTextField('year').setText(data.taxYear);
      form.getTextField('payer_name').setText(process.env.PAYER_NAME || 'Ginkgo Investment Mortgage Corporation');
      form.getTextField('payer_street').setText(process.env.PAYER_ADDRESS1 || '243 Consumers Road, Suite 210');
      form.getTextField('payer_addr2').setText(process.env.PAYER_ADDRESS2 || 'Toronto, ON M2J 4W8');
      form.getTextField('payer_phone').setText(process.env.PAYER_PHONE || '416-901-5133');
      switch (data.accountType) {
        case '3':
          form.getTextField('rcpt_name').setText(data.businessName);
          break;
        case '2':
          form.getTextField('rcpt_name').setText(data.fullName);
          break;
        case '1':
          form.getTextField('rcpt_name').setText(data.firstName + ' ' + data.lastName);
          break;
      }
      form.getTextField('rcpt_street').setText(data.street);
      form.getTextField('rcpt_addr2').setText(data.city + ' ' + data.province + ' ' + data.postCode);
      form.getTextField('rpt_code').setText(data.submmitCode);
      form.getTextField('type').setText(data.accountType);
      form.getTextField('account').setText(data.accountNum);
      form.flatten();
      // Serialize the PDFDocument to bytes (a Uint8Array)
      const pdfBytes = await pdfDoc.save();
      // Trigger the browser to download the PDF document
      download(pdfBytes, 'T5-' + data.accountNum + '-' + data.product + '-' + data.taxYear + '.pdf', 'application/pdf');
    } catch (error) {
      console.error('Error modifying PDF:', error);
    }
  };

  // Download NR4 PDF
  downloadNR4 = async (data: any) => {
    try {
      const url = 'https://ginkgowebsite.s3.us-east-2.amazonaws.com/nr4-24e.pdf';
      const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());
      const sinCode = data.recpId;
      const sin = await axios.get(baseURL + "/decodenr4sin?sin=" + sinCode);
      // Load a PDFDocument from the existing PDF bytes
      const pdfDoc = await PDFDocument.load(existingPdfBytes, { ignoreEncryption: true });
      // Get form
      const form = pdfDoc.getForm();
      // Fill form fields
      form.getTextField('recpId').setText(sin.data.toString());
      form.getTextField('grossIncome').setText(data.grossIncome.toString().replace('$', ''));
      form.getTextField('taxWithheld').setText((data.taxWithheld.toString()).replace('$', ''));
      form.getTextField('taxYear').setText(data.taxYear);
      form.getTextField('payerName').setText(process.env.PAYER_NAME || 'Ginkgo Investment Mortgage Corporation');
      form.getTextField('payerAddress1').setText(process.env.PAYER_ADDRESS1 || '243 Consumers Road, Suite 210');
      form.getTextField('payerAddress2').setText(process.env.PAYER_ADDRESS2 || 'Toronto, ON, CANADA M2J 4W8');
      form.getTextField('recpName').setText(data.recpName);
      form.getTextField('recpAddress1').setText(data.street);
      form.getTextField('recpAddress2').setText(data.city + ' ' + data.province + ' ' + 'CANADA ' + data.postCode);
      form.getTextField('recpCode').setText(data.recpCode);
      form.getTextField('currencyCode').setText("CAD");
      form.getTextField('incomeCode').setText(data.incomeCode);
      form.getTextField('exemptionCode').setText(data.exemptionCode);
      form.getTextField('countryCode').setText(data.recpCountryCode || ' ');
      form.getTextField('recpAccount').setText(data.recpAccount);
      form.getTextField('payerCountryCode').setText(data.payerCountryCode || ' ');
      form.flatten();
      // Serialize the PDFDocument to bytes (a Uint8Array)
      const pdfBytes = await pdfDoc.save();
      // Trigger the browser to download the PDF document
      download(pdfBytes, 'NR4-' + data.recpAccount + '-' + data.product + '-' + data.taxYear + '.pdf', 'application/pdf');
    } catch (error) {
      console.error('Error modifying PDF:', error);
    }
  };

  // Render advisor list table for modal
  renderAdvisorListTable = () => {
    const { advisors, advisorSearchText } = this.state;
    
    // Filter advisors based on search text
    const filteredAdvisors = advisors.filter(advisor => 
      advisor.advisorName?.toLowerCase().includes(advisorSearchText.toLowerCase()) ||
      advisor.email?.toLowerCase().includes(advisorSearchText.toLowerCase()) ||
      advisor.firstName?.toLowerCase().includes(advisorSearchText.toLowerCase()) ||
      advisor.lastName?.toLowerCase().includes(advisorSearchText.toLowerCase())
    );

    const columns = [
      {
        title: 'Advisor Name',
        key: 'advisorName',
        render: (record: any) => record.advisorName || `${record.firstName || ''} ${record.lastName || ''}`,
        sorter: (a: any, b: any) => {
          const aName = a.advisorName || `${a.firstName || ''} ${a.lastName || ''}`;
          const bName = b.advisorName || `${b.firstName || ''} ${b.lastName || ''}`;
          return aName.localeCompare(bName);
        },
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Client Count',
        key: 'clientCount',
        render: (record: any) => record.totalClient || record.clientCount || 0,
        sorter: (a: any, b: any) => (a.totalClient || a.clientCount || 0) - (b.totalClient || b.clientCount || 0),
      },
      {
        title: 'Total Assets',
        key: 'totalAssets',
        render: (record: any) => {
          const assets = record.totalAssets || record.totalAsset || 0;
          const numericValue = typeof assets === 'string' ? parseFloat(assets.replace(/[$,]/g, '') || '0') : assets;
          return `$${numericValue.toLocaleString()}`;
        },
        sorter: (a: any, b: any) => {
          const aAssets = a.totalAssets || a.totalAsset || 0;
          const bAssets = b.totalAssets || b.totalAsset || 0;
          const aValue = typeof aAssets === 'string' ? parseFloat(aAssets.replace(/[$,]/g, '') || '0') : aAssets;
          const bValue = typeof bAssets === 'string' ? parseFloat(bAssets.replace(/[$,]/g, '') || '0') : bAssets;
          return aValue - bValue;
        },
      },
      {
        title: 'Action',
        key: 'action',
        render: (record: any) => (
          <Button 
            type="primary" 
            onClick={() => this.selectAdvisorFromModal(record)}
          >
            Select
          </Button>
        ),
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={filteredAdvisors.map((advisor, index) => ({
          ...advisor,
          key: advisor.recId || advisor.advisorId || index
        }))}
        pagination={{ pageSize: 8 }}
        loading={this.state.loading}
        scroll={{ y: 400 }}
      />
    );
  };


  render() {
    const { adminSummary, selectedEMD, loading, adminInfo } = this.state;

    return (
      <div style={{ padding: '24px' }}>
        <div style={{ textAlign: 'center', marginBottom: '18px' }}>
          <div style={{ marginBottom: '16px' }}>
            <Title level={2} style={{ margin: 0 }}>Ginkgo Admin Dashboard</Title>
          </div>
          {adminInfo && (
            <div style={{ marginTop: '8px' }}>
              <Title level={4} style={{ color: '#1890ff', margin: 0 }}>
                Administrator
              </Title>
              <p style={{ color: '#666', margin: '4px 0' }}>
                {adminInfo.firstName} {adminInfo.lastName} • {this.state.isAuthenticated[1]}
              </p>
            </div>
          )}
        </div>

        {/* Early Access Program */}
        <RedemptionPoolChart
          month={this.state.redemptionMonth}
          year={this.state.redemptionYear}
          drip={this.state.dripTotal}
          newPurchase={this.state.newPurchaseTotal}
          totalRedemption={this.getTotalRedemption()}
          totalMatch={this.state.totalMatch}
          totalNonMatch={this.state.totalNonMatch}
          totalRetracted={this.state.totalRetracted}
          matchPeriodAllocated={this.state.matchPeriodAllocated}
          editable
          onPoolSave={this.saveMatchingFundPool}
          onPeriodChange={this.handleRedemptionPeriodChange}
          redemptionByFirm={this.getRedemptionByFirm()}
        />

        {/* Redemption Requests (editable for Admin) */}
        <Card
          title={(
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ whiteSpace: 'pre' }}>
                {buildListHeader('Retraction List', this.state.redemptionRecords)}
              </span>
              <Space size="small">
                <Popconfirm
                  title="Send the status update email to every advisor and investor with a Matched, Completed or Redeemed retraction this month?"
                  okText="Send"
                  cancelText="Cancel"
                  disabled={this.state.statusEmailSent || this.state.sendingStatusEmail}
                  onConfirm={this.sendStatusUpdateEmail}
                >
                  <Tooltip
                    title={
                      this.state.statusEmailSent
                        ? `Already sent${this.state.statusEmailSentAt ? ` on ${moment(this.state.statusEmailSentAt).format('YYYY-MM-DD HH:mm')}` : ''}`
                        : ''
                    }
                  >
                    <Button
                      type="primary"
                      style={{ backgroundColor: '#1890ff', borderColor: '#1890ff', color: '#fff' }}
                      disabled={this.state.statusEmailSent}
                      loading={this.state.sendingStatusEmail}
                    >
                      Send Status Update Email
                    </Button>
                  </Tooltip>
                </Popconfirm>
                <Button
                  type="primary"
                  style={{ backgroundColor: '#1890ff', borderColor: '#1890ff', color: '#fff' }}
                  disabled={this.state.dripTotal + this.state.newPurchaseTotal <= 0 || this.state.completingMatches}
                  loading={this.state.matching}
                  onClick={this.matchRedemptions}
                >
                  Match
                </Button>
                <Button
                  type="primary"
                  disabled={this.state.matchedCount <= 0 || this.state.matching}
                  loading={this.state.completingMatches}
                  onClick={this.markMatchesComplete}
                >
                  Mark Complete
                </Button>
              </Space>
            </div>
          )}
          style={{ marginBottom: '18px' }}
        >
          <RedemptionRequestTable
            records={this.state.redemptionRecords}
            loading={this.state.redemptionLoading}
            centerHeaders
            clientNameWrapChars={40}
            advisorWrapChars={40}
            emdWrapChars={40}
            addButtonLabel="New Record"
            addDisabled={isRedemptionPeriodLocked(
              this.state.redemptionMonth,
              this.state.redemptionYear,
            )}
            advisorOptions={this.state.advisorOptions}
            editable
            onSave={this.saveRedemptionRow}
            onAdd={this.addRedemptionRow}
            onAccountLookup={this.handleAccountLookup}
          />
        </Card>

        {/* Redemption Bookings (editable for Admin) */}
        <Card
          title={(
            <span style={{ whiteSpace: 'pre' }}>
              {buildListHeader('Retraction Booking List', this.state.bookingRecords)}
            </span>
          )}
          style={{ marginBottom: '18px' }}
        >
          <RedemptionBookingTable
            records={this.state.bookingRecords}
            loading={this.state.bookingLoading}
            centerHeaders
            clientNameWrapChars={40}
            advisorWrapChars={40}
            emdWrapChars={40}
            addButtonLabel="New Record"
            editable
            onSave={this.saveBookingRow}
            onAdd={this.addBookingRow}
            onDelete={this.deleteBookingRow}
            onAccountLookup={this.handleBookingAccountLookup}
          />
        </Card>

        {/* Tab Navigation */}
        {/* Admin Summary */}
            <Card style={{ marginBottom: '18px', backgroundColor: '#f0f8ff' }}>
              <Row gutter={24} justify="center">
                <Col span={6}>
                  <div style={{ textAlign: 'center' }}>
                    <Title level={3} style={{ color: '#1890ff', marginBottom: '5px' }}>
                      Total EMD Firms
                    </Title>
                    <Title level={1} style={{ color: '#1890ff', margin: 0 }}>
                      {adminSummary.totalEMDFirms}
                    </Title>
                  </div>
                </Col>
                <Col span={6}>
                  <div style={{ textAlign: 'center' }}>
                    <Title level={3} style={{ color: '#52c41a', marginBottom: '5px' }}>
                      Total Advisors
                    </Title>
                    <Title level={1} style={{ color: '#52c41a', margin: 0 }}>
                      {adminSummary.totalAdvisors}
                    </Title>
                  </div>
                </Col>
                <Col span={6}>
                  <div style={{ textAlign: 'center' }}>
                    <Title level={3} style={{ color: '#fa8c16', marginBottom: '5px' }}>
                      Total Clients
                    </Title>
                    <Title level={1} style={{ color: '#fa8c16', margin: 0 }}>
                      {adminSummary.totalClients}
                    </Title>
                  </div>
                </Col>
                <Col span={6}>
                  <div style={{ textAlign: 'center' }}>
                    <Title level={3} style={{ color: '#722ed1', marginBottom: '5px' }}>
                      Total Assets
                    </Title>
                    <Title level={1} style={{ color: '#722ed1', margin: 0 }}>
                      ${parseFloat(adminSummary.totalAssets?.replace(/[$,]/g, '') || '0').toLocaleString()}
                    </Title>
                  </div>
                </Col>
              </Row>
            </Card>

            {/* Action Buttons */}
            <div style={{ textAlign: 'center', marginBottom: '18px' }}>
              <Space size="middle" wrap>
                <Button
                  type="primary"
                  size="large"
                  icon={<TeamOutlined />}
                  onClick={this.showAllClientListModal}
                  style={{ minWidth: '150px' }}
                >
                  All Client List
                </Button>
                <Button
                  type="primary"
                  size="large"
                  icon={<UserOutlined />}
                  onClick={() => this.setState({ isUserManagementOpen: true })}
                  style={{ minWidth: '150px' }}
                >
                  User Management
                </Button>
                <Button 
                  type="primary" 
                  size="large"
                  onClick={this.showEMDListModal}
                  style={{ minWidth: '150px' }}
                >
                  EMD Firm List
                </Button>
                <Button 
                  type="primary" 
                  size="large"
                  icon={<FileTextOutlined />}
                  onClick={this.showRedemptionReportModal}
                  style={{ minWidth: '150px' }}
                >
                  Redemption Report
                </Button>
                <Button 
                  type="primary" 
                  size="large"
                  icon={<CalculatorOutlined />}
                  onClick={this.showCommissionReportModal}
                  style={{ minWidth: '150px' }}
                >
                  Trailer Fees Report
                </Button>
                <Button 
                  type="primary" 
                  size="large"
                  icon={<TrophyOutlined />}
                  onClick={this.showVIPListModal}
                  style={{ minWidth: '150px' }}
                >
                  Generate VIP List
                </Button>
                <Button 
                  type="primary" 
                  size="large"
                  icon={<FileTextOutlined />}
                  onClick={this.showT5NR4ReportModal}
                  style={{ minWidth: '150px' }}
                >
                  Generate T5/NR4
                </Button>
                <Button
                  type="primary"
                  size="large"
                  icon={<FileTextOutlined />}
                  onClick={this.showCatergoryMgmtModal}
                  style={{ minWidth: '150px' }}
                >
                  Catergories Management
                </Button>
                <Button
                  type="primary"
                  size="large"
                  icon={<UserOutlined />}
                  onClick={() => this.setState({ isAdvisorMgmtOpen: true })}
                  style={{ minWidth: '150px' }}
                >
                  Advisor Management
                </Button>
                <Button
                  type="primary"
                  size="large"
                  icon={<TeamOutlined />}
                  onClick={() => this.setState({ isEmdMgmtOpen: true })}
                  style={{ minWidth: '150px' }}
                >
                  EMD Management
                </Button>
              </Space>
            </div>

           {this.renderAdminSummaryTab()} 

           {/* EMD Dashboard Content */}
           {selectedEMD && (
             <div>
               {/* EMD Firm Dashboard */}
               <Card style={{ marginBottom: '18px', backgroundColor: '#f0f8ff' }}>
                 <div style={{ textAlign: 'center', marginBottom: '18px' }}>
                   <Title level={3} style={{ color: '#1890ff', margin: 0 }}>
                     {selectedEMD.firm} Dashboard
                   </Title>
                   <p style={{ color: '#666', margin: '4px 0' }}>
                     {selectedEMD.contactFirstname} {selectedEMD.contactLastname} • {selectedEMD.contactEmail}
                   </p>
                 </div>
                 <Row gutter={24} justify="center">
                   <Col span={8}>
                     <div style={{ textAlign: 'center' }}>
                       <Title level={3} style={{ color: '#1890ff', marginBottom: '5px' }}>
                         Total Advisors
                       </Title>
                       <Title level={1} style={{ color: '#1890ff', margin: 0 }}>
                         {selectedEMD.advisorCount || 0}
                       </Title>
                     </div>
                   </Col>
                   <Col span={8}>
                     <div style={{ textAlign: 'center' }}>
                       <Title level={3} style={{ color: '#52c41a', marginBottom: '5px' }}>
                         Total Clients
                       </Title>
                       <Title level={1} style={{ color: '#52c41a', margin: 0 }}>
                         {selectedEMD.clientCount || 0}
                       </Title>
                     </div>
                   </Col>
                   <Col span={8}>
                     <div style={{ textAlign: 'center' }}>
                       <Title level={3} style={{ color: '#52c41a', marginBottom: '5px' }}>
                         Total Assets
                       </Title>
                       <Title level={1} style={{ color: '#52c41a', margin: 0 }}>
                         ${parseFloat(selectedEMD.totalAssets?.replace(/[$,]/g, '') || '0').toLocaleString()}
                       </Title>
                     </div>
                   </Col>
                 </Row>
               </Card>

               {/* Action Buttons for EMD Dashboard */}
               <div style={{ textAlign: 'center', marginBottom: '18px' }}>
                 <Space size="middle">
                   <Button 
                     type="primary" 
                     size="large"
                     onClick={this.showAdvisorListModal}
                     disabled={!this.state.selectedEMD}
                     style={{ minWidth: '150px' }}
                   >
                     Advisor List
                   </Button>
                 </Space>
               </div>

               {/* Selected Advisor Information */}
               {this.state.selectedAdvisor && (
                 <Card title="Selected Advisor Information" style={{ marginBottom: '18px' }}>
                   <Descriptions column={2} bordered>
                     <Descriptions.Item label="Name">{this.state.selectedAdvisor.advisorName || `${this.state.selectedAdvisor.firstName} ${this.state.selectedAdvisor.lastName}`}</Descriptions.Item>
                     <Descriptions.Item label="Email">{this.state.selectedAdvisor.email}</Descriptions.Item>
                     <Descriptions.Item label="Firm">{this.state.selectedAdvisor.firm || selectedEMD.firm}</Descriptions.Item>
                     <Descriptions.Item label="Total Clients">{this.state.selectedAdvisor.totalClient || this.state.selectedAdvisor.clientCount}</Descriptions.Item>
                     <Descriptions.Item label="Total Assets" span={2}>
                       ${parseFloat(this.state.selectedAdvisor.totalAssets?.replace(/[$,]/g, '') || '0').toLocaleString()}
                     </Descriptions.Item>
                   </Descriptions>
                 </Card>
               )}

               {/* Detailed Advisor Portfolio Sections */}
               {this.state.selectedEMD && this.state.selectedAdvisor && (
                 <div style={{ textAlign: 'center', marginBottom: '18px' }}>
                   <Space size="middle">
                     <Button 
                       type="primary" 
                       size="large"
                       onClick={this.showClientListModal}
                       disabled={!this.state.selectedAdvisor}
                       style={{ minWidth: '150px' }}
                     >
                       Client List
                     </Button>
                   </Space>
                 </div>
               )}
             </div>
           )}

           {/* Client detail sections, driven by either the Client List or All Client List flow */}
           {this.state.partner && this.state.partner.recId && (
                  <div>
                   {/* Selected Client Information */}
                   {this.state.partner && this.state.partner.recId && (
                     <Card title="Current Client Information" style={{ marginBottom: '18px' }}>
                       <Descriptions column={2} bordered>
                         <Descriptions.Item label="Email">{this.state.partner.emailAddress || ''}</Descriptions.Item>
                         <Descriptions.Item label="First Name">{this.state.partner.firstName || ''}</Descriptions.Item>
                         <Descriptions.Item label="Last Name">{this.state.partner.lastName || ''}</Descriptions.Item>
                         <Descriptions.Item label="Full Name">{this.state.partner.fullName || ''}</Descriptions.Item>
                         <Descriptions.Item label="Phone">{this.state.partner.phoneHome || ''}</Descriptions.Item>
                       </Descriptions>
                     </Card>
                   )}

                   {/* Client Portfolio Table */}
                   <div>
                     <Title level={4} style={{ marginTop: '30px', marginBottom: '20px', textAlign: 'center' }}>Client  Portfolio</Title>
                     <div className="ant-table" style={{ display: 'flex', flex: 'auto', marginBottom: '18px' }}>
                       <table>
                         <thead className="ant-table-thead">
                           <tr>
                             <th>Account</th>
                             <th>Shares(S1) Balance</th>
                             <th>Shares(S2) Balance</th>
                             <th>Account Value</th>
                             <th>Commission/Trailer Fees(From {moment().subtract(9, "years").year()})</th>
                           </tr>
                         </thead>
                         <tbody className="ant-table-tbody">
                           {(this.state.totalAccountValue || []).map((value: any, i: number) => (
                             <tr key={i}>
                               <td>
                                 <a onClick={this.handleTagChange} id={value.partnerInfo.recId}>{value.partnerInfo.category} ({value.partnerInfo.account})</a>
                                 <Button
                                   type="primary"
                                   size="small"
                                   style={{ marginLeft: '8px' }}
                                   onClick={() => this.showPartnerCatergoryModal(value.partnerInfo.recId, value.partnerInfo.account)}
                                 >
                                   Catergories
                                 </Button>
                               </td>
                               <td>{Number(value.total_share_S1_balance || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                               <td>{Number(value.total_share_S2_balance || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                               <td>${Number(value.accountTotal || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                               <td><strong>${value.totalAccountTrailerFees || 0}</strong></td>
                             </tr>
                           ))}

                           {(!this.state.totalAccountValue || this.state.totalAccountValue.length === 0) && (
                             <tr>
                               <td colSpan={5} style={{ textAlign: 'center', padding: '16px' }}>
                                 No client accounts found for this advisor in the current environment.
                               </td>
                             </tr>
                           )}

                           {this.state.totalAccountValue && this.state.totalAccountValue.length > 0 && (
                             <tr>
                               <td></td>
                               <td></td>
                               <td></td>
                               <td><strong>Total Value: ${Number(this.state.totalAccountsValue || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}</strong></td>
                               <td><strong>Total Fees: ${Number(this.state.totalAccountsTrailerFees || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}</strong></td>
                             </tr>
                           )}
                         </tbody>
                       </table>
                     </div>
                   </div>

                   {/* Certificate Section */}
                   {this.state.displayAccountNum && (
                     <Collapse defaultActiveKey={['0']} style={{ marginBottom: '18px' }}>
                       <Panel header={`Certificates (Account:${this.state.displayAccountNum}) `} style={{ fontSize: "20px" }} key="1">
                         <div style={{marginTop: '40px'}}>
                           <Form name="time_related_controls" onFinish={this.onFinishCert} layout="inline"
                             initialValues={{'range-picker': [dayjs().startOf('year'), dayjs()]}}>
                             <Form.Item name="range-picker">
                               <RangePicker format="YYYY-MM-DD"/>
                             </Form.Item>
                             <Form.Item>
                               <Button type="primary" htmlType="submit">
                                 Search
                               </Button>
                             </Form.Item>
                             <Form.Item name="year-select">
                               <Radio.Group onChange={this.onClickCertYear}>
                                 <Radio.Button value="currentYear">This Year</Radio.Button> 
                                 <Radio.Button value="latestTwoYears">Last Two Years</Radio.Button>
                                 <Radio.Button value="allYears">All Years</Radio.Button>
                               </Radio.Group>
                             </Form.Item>					
                             <Form.Item name="product-select">
                               <Radio.Group onChange={this.onClickCertYear}>
                                 <Radio.Button value="GINKGO-S1">GINKGO-S1</Radio.Button>
                                 <Radio.Button value="GINKGO-S2">GINKGO-S2</Radio.Button>
                                 <Radio.Button value="All">All</Radio.Button>
                               </Radio.Group>
                             </Form.Item>					
                           </Form>
                         </div>
                         <div className="ant-table">
                           <table>
                             <thead className="ant-table-thead">
                               <tr>
                                 <th>Certificate #</th>
                                 <th>Product</th>
                                 <th>Shares</th>
                                 <th>Price</th>
                                 <th>Amount Paid</th>
                                 <th>Date Issued</th>               
                                 <th>Maturity Date</th>
                                 <th>Status</th>
                               </tr>
                             </thead>  
                             <tbody className="ant-table-tbody">
                               {this.state.certData && this.state.certData.map((cert:any, i:any)=>(      
                                 <tr className="ant-table-row" key={i}>
                                   <td>{cert.number}</td>
                                   <td>{cert.partnership?cert.partnership.account:''}</td>
                                   <td>{cert.transaction.length>0?Number(cert.transaction[0].shares).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,"):''}</td>
                                   <td>{cert.transaction.length>0?cert.transaction[0].sharePrice:''}</td>
                                   <td>{cert.transaction.length>0?cert.transaction[0].amount:''}</td>
                                   <td>{cert.issuedDate?moment(cert.issuedDate, "YYYY-MM-DD").format("YYYY-MM-DD"):''}</td>
                                   <td>{cert.maturity? moment(cert.maturity, "YYYY-MM-DD").format("YYYY-MM-DD") : ''}</td>
                                   <td>{
                                     (
                                       ()=>{
                                         if (cert.status === 0) {return 'active'}
                                         else if (cert.status === 1) {return 'redeemed'}
                                         else if (cert.status === 2) {return 'transferred'}
                                       }
                                     ) ()
                                   }</td>
                                 </tr>  
                               ))}
                               {this.state.certData && this.state.certData.length > 0 && (
                                 <tr>
                                   <td></td>
                                   <td></td>
                                   <td></td>
                                   <td></td>
                                   <td><strong>Total: ${Number((this.state.certSub_total || 0) * 10).toFixed(2)}</strong></td>
                                   <td></td>
                                   <td></td>
                                   <td></td>
                                 </tr>
                               )}           	                    
                             </tbody>
                           </table>
                         </div> 
                       </Panel>
                     </Collapse>
                   )}

                   {/* Transaction History Section */}
                   {this.state.displayAccountNum && (
                     <Collapse defaultActiveKey={['0']} style={{ marginBottom: '18px' }}>
                       <Panel header={`Transaction History (Account:${this.state.displayAccountNum})`} style={{ fontSize: "20px" }} key="2">
                         <div style={{marginTop: '40px'}}>
                           <Form name="transaction_time_controls" onFinish={this.onFinishTransaction} layout="inline" 
                             initialValues={{'transaction-range-picker': [dayjs().startOf('year'), dayjs()]}}>
                             <Form.Item name="transaction-range-picker">
                               <RangePicker format="YYYY-MM-DD"/>
                             </Form.Item>
                
                             <Form.Item>
                               <Button type="primary" htmlType="submit">
                                 Search
                               </Button>
                             </Form.Item>
                             <Form.Item name="transaction-year-select">
                               <Radio.Group onChange={this.onClickTransactionYear}>
                                 <Radio.Button value="currentYear">This Year</Radio.Button>
                                 <Radio.Button value="latestTwoYears">Last Two Years</Radio.Button>
                                 <Radio.Button value="allYears">All Years</Radio.Button>
                               </Radio.Group>
                             </Form.Item>					
                             <Form.Item name="transaction-product-select">
                               <Radio.Group onChange={this.onClickTransactionYear}>
                                 <Radio.Button value="GINKGO-S1">GINKGO-S1</Radio.Button>
                                 <Radio.Button value="GINKGO-S2">GINKGO-S2</Radio.Button>
                                 <Radio.Button value="All">All</Radio.Button>
                               </Radio.Group>
                             </Form.Item>					
                           </Form>
                         </div>
                         
                         <div className="ant-table">
                           <table>
                             <thead className="ant-table-thead">
                               <tr>
                                 <th>Date</th>
                                 <th>Product</th>
                                 <th>Description</th>
                                 <th>Shares</th>
                                 <th>Amount</th>               
                                 <th>Fee</th>
                                 <th>Withholding</th>
                                 <th>Certificate #</th>
                               </tr>
                             </thead>  
                             <tbody className="ant-table-tbody">
                               {this.state.transactionData && this.state.transactionData.map((trans:any, i:any)=>(                                               
                                 <tr className="ant-table-row" key={i}>
                                   <td>{moment(trans.recDate, "YYYY-MM-DD").format("YYYY-MM-DD")}</td>
                                   <td>{trans.partnership? trans.partnership.account : ''}</td>
                                   <td>{trans.memo}</td>
                                   <td>{Number(trans.shares).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>					
                                   <td>{trans.amount}</td>
                                   <td>{trans.penalty}</td>
                                   <td>{trans.holdBack}</td>
                                   <td>{trans.certificate? trans.certificate.number : ''}</td>					
                                 </tr>   
                               ))}
                             </tbody>
                           </table>
                         </div> 
                       </Panel>
                     </Collapse>
                   )}

                   {/* Redemption History Section */}
                   {this.state.displayAccountNum && (
                     <Collapse defaultActiveKey={['0']} style={{ marginBottom: '18px' }}>
                       <Panel header={`Redemption History (Account:${this.state.displayAccountNum})`} style={{ fontSize: "20px" }} key="3">
                         <div className="ant-table">
                           <table>
                             <thead className="ant-table-thead">
                               <tr>
                                 <th>Date</th>
                                 <th>Product</th>
                                 <th>Amount</th>               
                               </tr>
                             </thead>  
                             <tbody className="ant-table-tbody">
                               {this.state.redeemData ? (
                                 this.state.redeemData.map((redeem:any, i:any)=>(                                               
                                   <tr className="ant-table-row" key={i}>
                                     <td>{moment(redeem.redeemDate, "YYYY-MM-DD").format("YYYY-MM-DD")}</td>
                                     <td>{redeem.productId === '4097eb52-bcd6-4f56-b470-5b44e2bf6c54' ? 'S2' : 
                                     redeem.productId === '253a1dc7-3bdc-40d9-98c9-75ca619fb035' ? 'S1' : 
                                     redeem.productId === '0229bdc8-0f0f-4650-9a90-2ebda890c648' ? 'Bond B' : 'Bond A'}</td>
                                     <td>{redeem.redeemValue}</td>
                                   </tr>   
                                 ))
                               ) : (
                                 <tr className="ant-table-row">
                                   <td colSpan={3}>No data available</td>
                                 </tr>
                               )}
                             </tbody>
                           </table>
                         </div> 
                       </Panel>
                     </Collapse>
                   )}
                 </div>
               )}

           {/* Selected EMD Firm Information */}

              {/* Additional EMD dashboard content would go here */}
              {/* This would include advisor selection, client lists, etc. similar to portfolioEMD.tsx */}
 
        {/* EMD Firm List Modal */}
        <Modal
          title={
            <div style={{ textAlign: 'center', fontSize: '23px', fontWeight: 'bold' }}>
              EMD Firm List
            </div>
          }
          open={this.state.isEMDListModalOpen}
          onCancel={this.handleEMDListCancel}
          footer={null}
          width={1200}
        >
          <Input.Search
            placeholder="Search EMD Firms"
            onSearch={this.handleEMDSearch}
            style={{ marginBottom: 16 }}
          />
        {this.renderEMDListTable()}
        </Modal>

        {/* Redemption Report Modal */}
        <Modal
          title={
            <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>
              <FileTextOutlined style={{ marginRight: '8px' }} />
              Generate Redemption Report
            </div>
          }
          open={this.state.isRedemptionReportModalOpen}
          onCancel={this.handleRedemptionReportCancel}
          onOk={this.generateRedemptionReport}
          okText="Generate Report"
          okButtonProps={{ 
            icon: <DownloadOutlined />,
            loading: this.state.loading,
            type: 'primary'
          }}
          width={500}
        >
          <div style={{ padding: '16px 0' }}>
            <Title level={5}>Select Month for Redemption Report:</Title>
            <Select
              style={{ width: '100%' }}
              value={this.state.selectedReportMonth}
              onChange={this.handleRedemptionMonthChange}
              placeholder="Select month"
            >
              {Array.from({ length: 15 }, (_, i) => {
                const date = moment().subtract(i + 1, 'months');
                const value = date.format('YYYY-MM');
                const label = date.format('MMMM YYYY');
                return (
                  <Option key={value} value={value}>
                    {label}
                  </Option>
                );
              })}
            </Select>
            <p style={{ marginTop: '12px', color: '#666', fontSize: '14px' }}>
              This will generate a comprehensive redemption report for all EMD firms for the selected month.
            </p>
          </div>
        </Modal>

        {/* Commission Report Modal */}
        <Modal
          title={
            <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>
              <CalculatorOutlined style={{ marginRight: '8px' }} />
              Generate Commission/Trailler Fees Report
            </div>
          }
          open={this.state.isCommissionReportModalOpen}
          onCancel={this.handleCommissionReportCancel}
          onOk={this.generateCommissionReport}
          okText="Generate Report"
          okButtonProps={{ 
            icon: <DownloadOutlined />,
            loading: this.state.loading,
            type: 'primary'
          }}
          width={500}
        >
          <div style={{ padding: '16px 0' }}>
            <Title level={5}>Select Month for Commission/Trailler Fees Report:</Title>
            <Select
              style={{ width: '100%' }}
              value={this.state.selectedCommissionMonth}
              onChange={this.handleCommissionMonthChange}
              placeholder="Select month"
            >
              {Array.from({ length: 12 }, (_, i) => {
                const date = moment().add(1, 'months').subtract(i, 'months');
                const value = date.format('YYYY-MM');
                const label = date.format('MMMM YYYY');
                return (
                  <Option key={value} value={value}>
                    {label}
                  </Option>
                );
              })}
            </Select>
            <p style={{ marginTop: '12px', color: '#666', fontSize: '14px' }}>
              This will generate a comprehensive commission and trailler fees report for all EMD firms for the selected month.
            </p>
          </div>
        </Modal>

        {/* T5/NR4 Report Modal */}
        <Modal
          title={
            <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>
              <FileTextOutlined style={{ marginRight: '8px' }} />
              Generate T5/NR4 Report
            </div>
          }
          open={this.state.isT5NR4ReportModalOpen}
          onCancel={this.handleT5NR4ReportCancel}
          onOk={this.generateT5NR4Report}
          okText="Generate Report"
          okButtonProps={{ 
            icon: <DownloadOutlined />,
            loading: this.state.loading,
            type: 'primary'
          }}
          width={500}
        >
          <div style={{ padding: '16px 0' }}>
            <Title level={5}>Select Year:</Title>
            <Select
              style={{ width: '100%', marginBottom: '16px' }}
              value={this.state.selectedT5NR4Year}
              onChange={this.handleT5NR4YearChange}
              placeholder="Select year"
            >
              {Array.from({ length: 5 }, (_, i) => {
                const year = moment().subtract(i, 'years').format('YYYY');
                return (
                  <Option key={year} value={year}>
                    {year}
                  </Option>
                );
              })}
            </Select>
            
            <Title level={5}>Select Product:</Title>
            <Select
              style={{ width: '100%', marginBottom: '16px' }}
              value={this.state.selectedT5NR4Product}
              onChange={this.handleT5NR4ProductChange}
              placeholder="Select product"
            >
              <Option value="S1">S1</Option>
              <Option value="S2">S2</Option>
            </Select>
            
            <Title level={5}>Account Number:</Title>
            <Input
              style={{ width: '100%' }}
              value={this.state.selectedT5NR4AccNum}
              onChange={this.handleT5NR4AccNumChange}
              placeholder="Enter account number"
            />
            <p style={{ marginTop: '12px', color: '#666', fontSize: '14px' }}>
              Enter the account number to generate T5 (for Canadian residents) or NR4 (for non-residents) tax report.
            </p>
          </div>
        </Modal>

        {/* VIP List Modal */}
        <Modal
          title={
            <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>
              <TrophyOutlined style={{ marginRight: '8px' }} />
              Generate VIP List
            </div>
          }
          open={this.state.isVIPListModalOpen}
          onCancel={this.handleVIPListCancel}
          onOk={this.generateVIPList}
          okText="Generate List"
          okButtonProps={{ 
            icon: <DownloadOutlined />,
            loading: this.state.loading,
            type: 'primary'
          }}
          width={500}
        >
          <div style={{ padding: '16px 0' }}>
            <Title level={5}>Select Province:</Title>
            <Select
              style={{ width: '100%', marginBottom: '16px' }}
              value={this.state.selectedVIPProvince}
              onChange={this.handleVIPProvinceChange}
              placeholder="Select province (optional)"
              allowClear
            >
              <Option value="">All Provinces</Option>
              <Option value="BC">British Columbia (BC)</Option>
              <Option value="ON">Ontario (ON)</Option>
            </Select>
            
            <Title level={5}>Minimum Principal Value:</Title>
            <Select
              style={{ width: '100%', marginBottom: '8px' }}
              value={this.state.selectedVIPMinValue}
              onChange={this.handleVIPMinValueChange}
              placeholder="Select minimum value or enter custom"
              allowClear
            >
              <Option value="$5000">$5,000</Option>
              <Option value="$10000">$10,000</Option>
              <Option value="$25000">$25,000</Option>
              <Option value="$50000">$50,000</Option>
              <Option value="$100000">$100,000</Option>
              <Option value="$250000">$250,000</Option>
              <Option value="$500000">$500,000</Option>
              <Option value="$1000000">$1,000,000</Option>
            </Select>
            <Input
              style={{ width: '100%' }}
              value={this.state.selectedVIPMinValue}
              onChange={(e) => this.handleVIPMinValueChange(e.target.value)}
              placeholder="Or enter custom value (e.g., $15000)"
              prefix=""
            />
            <p style={{ marginTop: '12px', color: '#666', fontSize: '14px' }}>
              Select from the list or enter a custom minimum principal value.
            </p>
          </div>
        </Modal>

        {/* Advisor List Modal */}
        <Modal
          title={
            <div style={{ textAlign: 'center', fontSize: '23px', fontWeight: 'bold' }}>
              Advisor List
              {this.state.selectedEMD && (
                <div style={{ fontSize: '16px', fontWeight: 'normal', color: '#666', marginTop: '8px' }}>
                  EMD Firm: {this.state.selectedEMD.firm}
                </div>
              )}
            </div>
          }
          open={this.state.isAdvisorListModalOpen}
          onCancel={this.handleAdvisorListCancel}
          footer={null}
          width={1000}
        >
          <Input.Search
            placeholder="Search Advisors"
            onSearch={this.handleAdvisorSearch}
            style={{ marginBottom: 16 }}
          />
          {this.renderAdvisorListTable()}
        </Modal>

        {/* Client List Modal */}
        <Modal
          title={
            <div style={{ textAlign: 'center', fontSize: '23px', fontWeight: 'bold' }}>
              Client List
              {this.state.selectedAdvisor && (
                <div style={{ fontSize: '16px', fontWeight: 'normal', color: '#666', marginTop: '8px' }}>
                  Advisor: {this.state.selectedAdvisor.advisorName || `${this.state.selectedAdvisor.firstName} ${this.state.selectedAdvisor.lastName}`}
                </div>
              )}
            </div>
          }
          open={this.state.isModalOpen}
          onCancel={this.handleClientListCancel}
          onOk={this.handleClientListOk}
          width={1200}
        >
        <Input.Search placeholder="Name Search" onSearch={this.handleClientListSearch} style={{ marginBottom: 16 }}/>
        {this.renderClientListTable()}
        </Modal>

        <UserManagementModal
          open={this.state.isUserManagementOpen}
          onClose={() => this.setState({ isUserManagementOpen: false })}
          currentUserEmail={this.state.userEmail || undefined}
        />

        <AdvisorManagementModal
          open={this.state.isAdvisorMgmtOpen}
          onClose={() => this.setState({ isAdvisorMgmtOpen: false })}
        />

        <EMDManagementModal
          open={this.state.isEmdMgmtOpen}
          onClose={() => this.setState({ isEmdMgmtOpen: false })}
        />

        {/* All Client List Modal */}
        <Modal
          title={
            <div style={{ textAlign: 'center', fontSize: '23px', fontWeight: 'bold' }}>
              All Client List
              <div style={{ fontSize: '16px', fontWeight: 'normal', color: '#666', marginTop: '8px' }}>
                {this.state.allClientTotal} client{this.state.allClientTotal === 1 ? '' : 's'}
                {this.state.allClientSearchText ? ` matching "${this.state.allClientSearchText}"` : ''}
              </div>
            </div>
          }
          open={this.state.isAllClientListModalOpen}
          onCancel={this.handleAllClientListCancel}
          onOk={this.handleAllClientListOk}
          okButtonProps={{ disabled: !this.state.selectedAllClient }}
          confirmLoading={this.state.allClientListLoading}
          width={1300}
        >
          <Input.Search
            placeholder="Search by account #, first/last name, phone or email"
            defaultValue={this.state.allClientSearchText}
            allowClear
            onSearch={this.handleAllClientSearch}
            style={{ marginBottom: 16 }}
          />
          {this.renderAllClientListTable()}
        </Modal>

        {/* Partner Catergories Modal */}
        <Modal
          title={
            <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>
              Catergories
              {this.state.partnerCatergoryAccount && (
                <div style={{ fontSize: '14px', fontWeight: 'normal', color: '#666', marginTop: '8px' }}>
                  Account: {this.state.partnerCatergoryAccount}
                </div>
              )}
            </div>
          }
          open={this.state.isPartnerCatergoryModalOpen}
          onCancel={this.handlePartnerCatergoryCancel}
          onOk={this.handlePartnerCatergoryOk}
          okText="OK"
          confirmLoading={this.state.partnerCatergoryLoading}
          width={520}
        >
          <Table
            rowKey="recId"
            loading={this.state.partnerCatergoryLoading}
            dataSource={this.state.partnerCatergoryList}
            columns={[{ title: 'Catergory', dataIndex: 'description', key: 'description' }]}
            rowSelection={{
              selectedRowKeys: this.state.partnerCatergorySelectedKeys,
              onChange: (keys: any) =>
                this.setState({ partnerCatergorySelectedKeys: keys as string[] }),
            }}
            pagination={{
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50', '100'],
            }}
            size="small"
            locale={{ emptyText: 'No catergories found.' }}
          />
          <p style={{ marginTop: '12px', color: '#666', fontSize: '14px' }}>
            Checked catergories belong to this account and are listed first. Click OK to save.
          </p>
        </Modal>

        {/* Catergories Management Modal */}
        <Modal
          title={
            <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>
              Catergories Management
            </div>
          }
          open={this.state.isCatergoryMgmtModalOpen}
          onCancel={this.handleCatergoryMgmtCancel}
          onOk={this.handleCatergoryMgmtOk}
          okText="OK"
          confirmLoading={this.state.catergoryMgmtLoading}
          width={600}
        >
          <Space style={{ marginBottom: 16 }} wrap>
            <Input
              placeholder={
                this.state.catergoryEditingRecId
                  ? 'Edit catergory value'
                  : 'New catergory value'
              }
              value={this.state.catergoryNewValue}
              maxLength={30}
              onChange={this.handleCatergoryNewValueChange}
              onPressEnter={this.handleCatergorySubmitValue}
              style={{ width: 240 }}
            />
            <Button type="primary" onClick={this.handleCatergorySubmitValue}>
              {this.state.catergoryEditingRecId ? 'Save' : 'Add'}
            </Button>
            {this.state.catergoryEditingRecId ? (
              <Button onClick={this.handleCatergoryCancelEdit}>Cancel Edit</Button>
            ) : (
              <Button
                disabled={this.state.catergorySelectedKeys.length !== 1}
                onClick={this.handleCatergoryEditSelected}
              >
                Edit Selected
              </Button>
            )}
            <Popconfirm
              title="Remove the selected catergories?"
              onConfirm={this.handleCatergoryDeleteSelected}
              okText="Yes"
              cancelText="No"
              disabled={this.state.catergorySelectedKeys.length === 0}
            >
              <Button danger disabled={this.state.catergorySelectedKeys.length === 0}>
                Delete Selected
              </Button>
            </Popconfirm>
          </Space>
          <Table
            rowKey="recId"
            loading={this.state.catergoryMgmtLoading}
            dataSource={this.state.catergoryRows}
            columns={[
              {
                title: 'Catergory',
                dataIndex: 'description',
                key: 'description',
                render: (text: string, record: any) => (
                  <span>
                    {text}
                    {record.isNew && <em style={{ color: '#52c41a' }}> (new)</em>}
                    {record.isEdited && <em style={{ color: '#fa8c16' }}> (edited)</em>}
                  </span>
                ),
              },
            ]}
            rowSelection={{
              selectedRowKeys: this.state.catergorySelectedKeys,
              onChange: (keys: any) =>
                this.setState({ catergorySelectedKeys: keys as string[] }),
            }}
            pagination={{
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50', '100'],
            }}
            size="small"
          />
          <p style={{ marginTop: '12px', color: '#666', fontSize: '14px' }}>
            Select one row to edit it. Changes are saved when you click OK. Values cannot be duplicated.
          </p>
        </Modal>
      </div>
    );
  }
}

export default withRouter(PortfolioAdmin);
